import axios from 'axios';

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
/**
* Access options for vod items

1 = Free

2 = Registration

3 = Subscribe
* @format int32
*/
var AccessOptions;
(function (AccessOptions) {
    AccessOptions[AccessOptions["Free"] = 1] = "Free";
    AccessOptions[AccessOptions["Registration"] = 2] = "Registration";
    AccessOptions[AccessOptions["Subscribe"] = 3] = "Subscribe";
})(AccessOptions || (AccessOptions = {}));
/**
*

0 = WithPremiumBasic

1 = BasicPacksPromo

2 = InternetFttn50

3 = Phone1MonthFree

4 = PremiumBasic2MonthsFree
* @format int32
*/
var AdditionalPriceType;
(function (AdditionalPriceType) {
    AdditionalPriceType[AdditionalPriceType["WithPremiumBasic"] = 0] = "WithPremiumBasic";
    AdditionalPriceType[AdditionalPriceType["BasicPacksPromo"] = 1] = "BasicPacksPromo";
    AdditionalPriceType[AdditionalPriceType["InternetFttn50"] = 2] = "InternetFttn50";
    AdditionalPriceType[AdditionalPriceType["Phone1MonthFree"] = 3] = "Phone1MonthFree";
    AdditionalPriceType[AdditionalPriceType["PremiumBasic2MonthsFree"] = 4] = "PremiumBasic2MonthsFree";
})(AdditionalPriceType || (AdditionalPriceType = {}));
/**
* Predefined list of possible content advisory raitings.

0 = NR

1 = PG1

2 = PG2

3 = PG3

4 = PG4

5 = R
* @format int32
*/
var Advisory;
(function (Advisory) {
    Advisory[Advisory["NR"] = 0] = "NR";
    Advisory[Advisory["PG1"] = 1] = "PG1";
    Advisory[Advisory["PG2"] = 2] = "PG2";
    Advisory[Advisory["PG3"] = 3] = "PG3";
    Advisory[Advisory["PG4"] = 4] = "PG4";
    Advisory[Advisory["R"] = 5] = "R";
})(Advisory || (Advisory = {}));
/**
*

0 = None

601 = EnterCooldown

602 = NoInformationTiedToVerificationCode

603 = ErrorDuringLogin

604 = ExceptionDuringLogin

605 = NoDeviceTiedToVerificationCode

606 = CodesGenerationFailed
* @format int32
*/
var ApiCode;
(function (ApiCode) {
    ApiCode[ApiCode["None"] = 0] = "None";
    ApiCode[ApiCode["EnterCooldown"] = 601] = "EnterCooldown";
    ApiCode[ApiCode["NoInformationTiedToVerificationCode"] = 602] = "NoInformationTiedToVerificationCode";
    ApiCode[ApiCode["ErrorDuringLogin"] = 603] = "ErrorDuringLogin";
    ApiCode[ApiCode["ExceptionDuringLogin"] = 604] = "ExceptionDuringLogin";
    ApiCode[ApiCode["NoDeviceTiedToVerificationCode"] = 605] = "NoDeviceTiedToVerificationCode";
    ApiCode[ApiCode["CodesGenerationFailed"] = 606] = "CodesGenerationFailed";
})(ApiCode || (ApiCode = {}));
/**
* Content level item

1 = Series

2 = Season

3 = Episode

4 = Movie
* @format int32
*/
var AppleContentLevel;
(function (AppleContentLevel) {
    AppleContentLevel[AppleContentLevel["Series"] = 1] = "Series";
    AppleContentLevel[AppleContentLevel["Season"] = 2] = "Season";
    AppleContentLevel[AppleContentLevel["Episode"] = 3] = "Episode";
    AppleContentLevel[AppleContentLevel["Movie"] = 4] = "Movie";
})(AppleContentLevel || (AppleContentLevel = {}));
/**
* Brand

0 = Vianet

1 = VMedia

3 = River

5 = ChannelZero

6 = Fizz

7 = Other

8 = FreedomMobile

9 = HealthHub

16 = LocMedical

-1 = Undefined
* @format int32
*/
var Brand;
(function (Brand) {
    Brand[Brand["Vianet"] = 0] = "Vianet";
    Brand[Brand["VMedia"] = 1] = "VMedia";
    Brand[Brand["River"] = 3] = "River";
    Brand[Brand["ChannelZero"] = 5] = "ChannelZero";
    Brand[Brand["Fizz"] = 6] = "Fizz";
    Brand[Brand["Other"] = 7] = "Other";
    Brand[Brand["FreedomMobile"] = 8] = "FreedomMobile";
    Brand[Brand["HealthHub"] = 9] = "HealthHub";
    Brand[Brand["LocMedical"] = 16] = "LocMedical";
    Brand[Brand["Undefined"] = -1] = "Undefined";
})(Brand || (Brand = {}));
/**
*

1 = NoServiceAvailable

2 = InternetCheckout

3 = TvCheckout
* @format int32
*/
var CheckoutType;
(function (CheckoutType) {
    CheckoutType[CheckoutType["NoServiceAvailable"] = 1] = "NoServiceAvailable";
    CheckoutType[CheckoutType["InternetCheckout"] = 2] = "InternetCheckout";
    CheckoutType[CheckoutType["TvCheckout"] = 3] = "TvCheckout";
})(CheckoutType || (CheckoutType = {}));
/**
* Client message types

0 = Text

101 = FullRefreshCommand

102 = GuideRefreshCommand

103 = ChannelRefreshCommand

104 = LogoutCommand

105 = BlockingMessage

106 = InformationalMessage

107 = InAppMessagePushNotification

108 = InAppMessageOnly
* @format int32
*/
var ClientMessageType;
(function (ClientMessageType) {
    ClientMessageType[ClientMessageType["Text"] = 0] = "Text";
    ClientMessageType[ClientMessageType["FullRefreshCommand"] = 101] = "FullRefreshCommand";
    ClientMessageType[ClientMessageType["GuideRefreshCommand"] = 102] = "GuideRefreshCommand";
    ClientMessageType[ClientMessageType["ChannelRefreshCommand"] = 103] = "ChannelRefreshCommand";
    ClientMessageType[ClientMessageType["LogoutCommand"] = 104] = "LogoutCommand";
    ClientMessageType[ClientMessageType["BlockingMessage"] = 105] = "BlockingMessage";
    ClientMessageType[ClientMessageType["InformationalMessage"] = 106] = "InformationalMessage";
    ClientMessageType[ClientMessageType["InAppMessagePushNotification"] = 107] = "InAppMessagePushNotification";
    ClientMessageType[ClientMessageType["InAppMessageOnly"] = 108] = "InAppMessageOnly";
})(ClientMessageType || (ClientMessageType = {}));
/**
*

1 = SceneIsOpen

2 = SceneIsClosed

3 = SceneIsActive

4 = SceneIsInactive

21 = ServiceIsAvailable

22 = ServiceIsEnabled

51 = PlayerStatePlaying

52 = PlayerStatePaused

53 = PlayerStateStopped

54 = PlayerStateRewind

55 = PlayerStateFlashforward

101 = ValueIsTrue

102 = ValueIsFalse
* @format int32
*/
var ConditionType;
(function (ConditionType) {
    ConditionType[ConditionType["SceneIsOpen"] = 1] = "SceneIsOpen";
    ConditionType[ConditionType["SceneIsClosed"] = 2] = "SceneIsClosed";
    ConditionType[ConditionType["SceneIsActive"] = 3] = "SceneIsActive";
    ConditionType[ConditionType["SceneIsInactive"] = 4] = "SceneIsInactive";
    ConditionType[ConditionType["ServiceIsAvailable"] = 21] = "ServiceIsAvailable";
    ConditionType[ConditionType["ServiceIsEnabled"] = 22] = "ServiceIsEnabled";
    ConditionType[ConditionType["PlayerStatePlaying"] = 51] = "PlayerStatePlaying";
    ConditionType[ConditionType["PlayerStatePaused"] = 52] = "PlayerStatePaused";
    ConditionType[ConditionType["PlayerStateStopped"] = 53] = "PlayerStateStopped";
    ConditionType[ConditionType["PlayerStateRewind"] = 54] = "PlayerStateRewind";
    ConditionType[ConditionType["PlayerStateFlashforward"] = 55] = "PlayerStateFlashforward";
    ConditionType[ConditionType["ValueIsTrue"] = 101] = "ValueIsTrue";
    ConditionType[ConditionType["ValueIsFalse"] = 102] = "ValueIsFalse";
})(ConditionType || (ConditionType = {}));
/**
* Definition of types of genres depending on the type of client services (such as Live TV, VOD etc.)

0 = UnknownGenreType

1 = TvGenreType

2 = VodGenreType

3 = ProgramGenreType

4 = ArcplusGenreType

5 = VodInternalGenreType
* @format int32
*/
var ContentGenreType;
(function (ContentGenreType) {
    ContentGenreType[ContentGenreType["UnknownGenreType"] = 0] = "UnknownGenreType";
    ContentGenreType[ContentGenreType["TvGenreType"] = 1] = "TvGenreType";
    ContentGenreType[ContentGenreType["VodGenreType"] = 2] = "VodGenreType";
    ContentGenreType[ContentGenreType["ProgramGenreType"] = 3] = "ProgramGenreType";
    ContentGenreType[ContentGenreType["ArcplusGenreType"] = 4] = "ArcplusGenreType";
    ContentGenreType[ContentGenreType["VodInternalGenreType"] = 5] = "VodInternalGenreType";
})(ContentGenreType || (ContentGenreType = {}));
/**
*

0 = AudioBooks

1 = DVR

2 = Games

3 = Karaoke

4 = LiveTV

5 = Music

6 = Podcast

7 = Radio

8 = ArcPlus

9 = VOD

10 = SVOD

11 = CraveTV
* @format int32
*/
var ContentType;
(function (ContentType) {
    ContentType[ContentType["AudioBooks"] = 0] = "AudioBooks";
    ContentType[ContentType["DVR"] = 1] = "DVR";
    ContentType[ContentType["Games"] = 2] = "Games";
    ContentType[ContentType["Karaoke"] = 3] = "Karaoke";
    ContentType[ContentType["LiveTV"] = 4] = "LiveTV";
    ContentType[ContentType["Music"] = 5] = "Music";
    ContentType[ContentType["Podcast"] = 6] = "Podcast";
    ContentType[ContentType["Radio"] = 7] = "Radio";
    ContentType[ContentType["ArcPlus"] = 8] = "ArcPlus";
    ContentType[ContentType["VOD"] = 9] = "VOD";
    ContentType[ContentType["SVOD"] = 10] = "SVOD";
    ContentType[ContentType["CraveTV"] = 11] = "CraveTV";
})(ContentType || (ContentType = {}));
/**
* Type of credits request.

1 = Item

2 = Season

3 = Container
* @format int32
*/
var CreditsRequestType;
(function (CreditsRequestType) {
    CreditsRequestType[CreditsRequestType["Item"] = 1] = "Item";
    CreditsRequestType[CreditsRequestType["Season"] = 2] = "Season";
    CreditsRequestType[CreditsRequestType["Container"] = 3] = "Container";
})(CreditsRequestType || (CreditsRequestType = {}));
/**
* Stream DRM behavior

0 = UseDefault

1 = ForceClearKey
* @format int32
*/
var DrmBehavior;
(function (DrmBehavior) {
    DrmBehavior[DrmBehavior["UseDefault"] = 0] = "UseDefault";
    DrmBehavior[DrmBehavior["ForceClearKey"] = 1] = "ForceClearKey";
})(DrmBehavior || (DrmBehavior = {}));
/**
* DRM type

0 = None

1 = Clearkey

2 = Widevine

3 = PlayReady

4 = Fairplay
* @format int32
*/
var DrmType;
(function (DrmType) {
    DrmType[DrmType["None"] = 0] = "None";
    DrmType[DrmType["Clearkey"] = 1] = "Clearkey";
    DrmType[DrmType["Widevine"] = 2] = "Widevine";
    DrmType[DrmType["PlayReady"] = 3] = "PlayReady";
    DrmType[DrmType["Fairplay"] = 4] = "Fairplay";
})(DrmType || (DrmType = {}));
/**
* Status of forgot password

1 = Success

2 = UserNotFound

3 = ApplicationIsNotSupported
* @format int32
*/
var ForgotPasswordStatus;
(function (ForgotPasswordStatus) {
    ForgotPasswordStatus[ForgotPasswordStatus["Success"] = 1] = "Success";
    ForgotPasswordStatus[ForgotPasswordStatus["UserNotFound"] = 2] = "UserNotFound";
    ForgotPasswordStatus[ForgotPasswordStatus["ApplicationIsNotSupported"] = 3] = "ApplicationIsNotSupported";
})(ForgotPasswordStatus || (ForgotPasswordStatus = {}));
/**
* genre types premium/basic

1 = Basic

2 = Premium
* @format int32
*/
var GenreType;
(function (GenreType) {
    GenreType[GenreType["Basic"] = 1] = "Basic";
    GenreType[GenreType["Premium"] = 2] = "Premium";
})(GenreType || (GenreType = {}));
/**
* status of guest validation transaction

1 = Success

2 = UserNotFoundForCurrentTransaction

-5 = ExternalPackageHaveNotPackageId

-4 = ExternalPackageDoesntEqual

-3 = DontHaveLatestReceiptInfo

-2 = ReceiptExpired

-1 = Error
* @format int32
*/
var GuestTransactionStatus;
(function (GuestTransactionStatus) {
    GuestTransactionStatus[GuestTransactionStatus["Success"] = 1] = "Success";
    GuestTransactionStatus[GuestTransactionStatus["UserNotFoundForCurrentTransaction"] = 2] = "UserNotFoundForCurrentTransaction";
    GuestTransactionStatus[GuestTransactionStatus["ExternalPackageHaveNotPackageId"] = -5] = "ExternalPackageHaveNotPackageId";
    GuestTransactionStatus[GuestTransactionStatus["ExternalPackageDoesntEqual"] = -4] = "ExternalPackageDoesntEqual";
    GuestTransactionStatus[GuestTransactionStatus["DontHaveLatestReceiptInfo"] = -3] = "DontHaveLatestReceiptInfo";
    GuestTransactionStatus[GuestTransactionStatus["ReceiptExpired"] = -2] = "ReceiptExpired";
    GuestTransactionStatus[GuestTransactionStatus["Error"] = -1] = "Error";
})(GuestTransactionStatus || (GuestTransactionStatus = {}));
/**
*

100 = Continue

101 = SwitchingProtocols

102 = Processing

103 = EarlyHints

200 = OK

201 = Created

202 = Accepted

203 = NonAuthoritativeInformation

204 = NoContent

205 = ResetContent

206 = PartialContent

207 = MultiStatus

208 = AlreadyReported

226 = IMUsed

300 = Ambiguous

301 = Moved

302 = Redirect

303 = RedirectMethod

304 = NotModified

305 = UseProxy

306 = Unused

307 = RedirectKeepVerb

308 = PermanentRedirect

400 = BadRequest

401 = Unauthorized

402 = PaymentRequired

403 = Forbidden

404 = NotFound

405 = MethodNotAllowed

406 = NotAcceptable

407 = ProxyAuthenticationRequired

408 = RequestTimeout

409 = Conflict

410 = Gone

411 = LengthRequired

412 = PreconditionFailed

413 = RequestEntityTooLarge

414 = RequestUriTooLong

415 = UnsupportedMediaType

416 = RequestedRangeNotSatisfiable

417 = ExpectationFailed

421 = MisdirectedRequest

422 = UnprocessableContent

423 = Locked

424 = FailedDependency

426 = UpgradeRequired

428 = PreconditionRequired

429 = TooManyRequests

431 = RequestHeaderFieldsTooLarge

451 = UnavailableForLegalReasons

500 = InternalServerError

501 = NotImplemented

502 = BadGateway

503 = ServiceUnavailable

504 = GatewayTimeout

505 = HttpVersionNotSupported

506 = VariantAlsoNegotiates

507 = InsufficientStorage

508 = LoopDetected

510 = NotExtended

511 = NetworkAuthenticationRequired
* @format int32
*/
var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode[HttpStatusCode["Continue"] = 100] = "Continue";
    HttpStatusCode[HttpStatusCode["SwitchingProtocols"] = 101] = "SwitchingProtocols";
    HttpStatusCode[HttpStatusCode["Processing"] = 102] = "Processing";
    HttpStatusCode[HttpStatusCode["EarlyHints"] = 103] = "EarlyHints";
    HttpStatusCode[HttpStatusCode["OK"] = 200] = "OK";
    HttpStatusCode[HttpStatusCode["Created"] = 201] = "Created";
    HttpStatusCode[HttpStatusCode["Accepted"] = 202] = "Accepted";
    HttpStatusCode[HttpStatusCode["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
    HttpStatusCode[HttpStatusCode["NoContent"] = 204] = "NoContent";
    HttpStatusCode[HttpStatusCode["ResetContent"] = 205] = "ResetContent";
    HttpStatusCode[HttpStatusCode["PartialContent"] = 206] = "PartialContent";
    HttpStatusCode[HttpStatusCode["MultiStatus"] = 207] = "MultiStatus";
    HttpStatusCode[HttpStatusCode["AlreadyReported"] = 208] = "AlreadyReported";
    HttpStatusCode[HttpStatusCode["IMUsed"] = 226] = "IMUsed";
    HttpStatusCode[HttpStatusCode["Ambiguous"] = 300] = "Ambiguous";
    HttpStatusCode[HttpStatusCode["Moved"] = 301] = "Moved";
    HttpStatusCode[HttpStatusCode["Redirect"] = 302] = "Redirect";
    HttpStatusCode[HttpStatusCode["RedirectMethod"] = 303] = "RedirectMethod";
    HttpStatusCode[HttpStatusCode["NotModified"] = 304] = "NotModified";
    HttpStatusCode[HttpStatusCode["UseProxy"] = 305] = "UseProxy";
    HttpStatusCode[HttpStatusCode["Unused"] = 306] = "Unused";
    HttpStatusCode[HttpStatusCode["RedirectKeepVerb"] = 307] = "RedirectKeepVerb";
    HttpStatusCode[HttpStatusCode["PermanentRedirect"] = 308] = "PermanentRedirect";
    HttpStatusCode[HttpStatusCode["BadRequest"] = 400] = "BadRequest";
    HttpStatusCode[HttpStatusCode["Unauthorized"] = 401] = "Unauthorized";
    HttpStatusCode[HttpStatusCode["PaymentRequired"] = 402] = "PaymentRequired";
    HttpStatusCode[HttpStatusCode["Forbidden"] = 403] = "Forbidden";
    HttpStatusCode[HttpStatusCode["NotFound"] = 404] = "NotFound";
    HttpStatusCode[HttpStatusCode["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    HttpStatusCode[HttpStatusCode["NotAcceptable"] = 406] = "NotAcceptable";
    HttpStatusCode[HttpStatusCode["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
    HttpStatusCode[HttpStatusCode["RequestTimeout"] = 408] = "RequestTimeout";
    HttpStatusCode[HttpStatusCode["Conflict"] = 409] = "Conflict";
    HttpStatusCode[HttpStatusCode["Gone"] = 410] = "Gone";
    HttpStatusCode[HttpStatusCode["LengthRequired"] = 411] = "LengthRequired";
    HttpStatusCode[HttpStatusCode["PreconditionFailed"] = 412] = "PreconditionFailed";
    HttpStatusCode[HttpStatusCode["RequestEntityTooLarge"] = 413] = "RequestEntityTooLarge";
    HttpStatusCode[HttpStatusCode["RequestUriTooLong"] = 414] = "RequestUriTooLong";
    HttpStatusCode[HttpStatusCode["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    HttpStatusCode[HttpStatusCode["RequestedRangeNotSatisfiable"] = 416] = "RequestedRangeNotSatisfiable";
    HttpStatusCode[HttpStatusCode["ExpectationFailed"] = 417] = "ExpectationFailed";
    HttpStatusCode[HttpStatusCode["MisdirectedRequest"] = 421] = "MisdirectedRequest";
    HttpStatusCode[HttpStatusCode["UnprocessableContent"] = 422] = "UnprocessableContent";
    HttpStatusCode[HttpStatusCode["Locked"] = 423] = "Locked";
    HttpStatusCode[HttpStatusCode["FailedDependency"] = 424] = "FailedDependency";
    HttpStatusCode[HttpStatusCode["UpgradeRequired"] = 426] = "UpgradeRequired";
    HttpStatusCode[HttpStatusCode["PreconditionRequired"] = 428] = "PreconditionRequired";
    HttpStatusCode[HttpStatusCode["TooManyRequests"] = 429] = "TooManyRequests";
    HttpStatusCode[HttpStatusCode["RequestHeaderFieldsTooLarge"] = 431] = "RequestHeaderFieldsTooLarge";
    HttpStatusCode[HttpStatusCode["UnavailableForLegalReasons"] = 451] = "UnavailableForLegalReasons";
    HttpStatusCode[HttpStatusCode["InternalServerError"] = 500] = "InternalServerError";
    HttpStatusCode[HttpStatusCode["NotImplemented"] = 501] = "NotImplemented";
    HttpStatusCode[HttpStatusCode["BadGateway"] = 502] = "BadGateway";
    HttpStatusCode[HttpStatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HttpStatusCode[HttpStatusCode["GatewayTimeout"] = 504] = "GatewayTimeout";
    HttpStatusCode[HttpStatusCode["HttpVersionNotSupported"] = 505] = "HttpVersionNotSupported";
    HttpStatusCode[HttpStatusCode["VariantAlsoNegotiates"] = 506] = "VariantAlsoNegotiates";
    HttpStatusCode[HttpStatusCode["InsufficientStorage"] = 507] = "InsufficientStorage";
    HttpStatusCode[HttpStatusCode["LoopDetected"] = 508] = "LoopDetected";
    HttpStatusCode[HttpStatusCode["NotExtended"] = 510] = "NotExtended";
    HttpStatusCode[HttpStatusCode["NetworkAuthenticationRequired"] = 511] = "NetworkAuthenticationRequired";
})(HttpStatusCode || (HttpStatusCode = {}));
/**
*

0 = RequestVersionOrLower

1 = RequestVersionOrHigher

2 = RequestVersionExact
* @format int32
*/
var HttpVersionPolicy;
(function (HttpVersionPolicy) {
    HttpVersionPolicy[HttpVersionPolicy["RequestVersionOrLower"] = 0] = "RequestVersionOrLower";
    HttpVersionPolicy[HttpVersionPolicy["RequestVersionOrHigher"] = 1] = "RequestVersionOrHigher";
    HttpVersionPolicy[HttpVersionPolicy["RequestVersionExact"] = 2] = "RequestVersionExact";
})(HttpVersionPolicy || (HttpVersionPolicy = {}));
/**
* VOD/guide item type

0 = Schedule

1 = Program

2 = Container

3 = Episode

4 = Movie

5 = Season
* @format int32
*/
var ItemType;
(function (ItemType) {
    ItemType[ItemType["Schedule"] = 0] = "Schedule";
    ItemType[ItemType["Program"] = 1] = "Program";
    ItemType[ItemType["Container"] = 2] = "Container";
    ItemType[ItemType["Episode"] = 3] = "Episode";
    ItemType[ItemType["Movie"] = 4] = "Movie";
    ItemType[ItemType["Season"] = 5] = "Season";
})(ItemType || (ItemType = {}));
/**
* Language

0 = None

1 = Eng

5 = Fra
* @format int32
*/
var Language;
(function (Language) {
    Language[Language["None"] = 0] = "None";
    Language[Language["Eng"] = 1] = "Eng";
    Language[Language["Fra"] = 5] = "Fra";
})(Language || (Language = {}));
/**
* Level of subscription for channel zero users

1 = Guest

2 = FreeSubscriber

3 = PaidSubscriber

-1 = Undefined
* @format int32
*/
var LevelSubscription;
(function (LevelSubscription) {
    LevelSubscription[LevelSubscription["Guest"] = 1] = "Guest";
    LevelSubscription[LevelSubscription["FreeSubscriber"] = 2] = "FreeSubscriber";
    LevelSubscription[LevelSubscription["PaidSubscriber"] = 3] = "PaidSubscriber";
    LevelSubscription[LevelSubscription["Undefined"] = -1] = "Undefined";
})(LevelSubscription || (LevelSubscription = {}));
/**
*

1 = Chum

2 = Beauceville
* @format int32
*/
var LocMedicalHospital;
(function (LocMedicalHospital) {
    LocMedicalHospital[LocMedicalHospital["Chum"] = 1] = "Chum";
    LocMedicalHospital[LocMedicalHospital["Beauceville"] = 2] = "Beauceville";
})(LocMedicalHospital || (LocMedicalHospital = {}));
/**
*

1 = VodMain

4 = ChannelLogoTransparent36

8 = ChannelLogoWhiteTransparent

10 = ChannelLogoOriginal

28 = TvProgram

29 = TvProgram16x9

41 = VodGenre

42 = VodGenreMonochrome

43 = VodScreenshot

44 = VodWallpaper

45 = VodCredit

46 = VodPerson

47 = Season

48 = Episode

49 = TopShelf

50 = Label

51 = VodTopGenrePoster

52 = VodTopGenreWallpaper

101 = StoreProduct
* @format int32
*/
var MediaImageTypes;
(function (MediaImageTypes) {
    MediaImageTypes[MediaImageTypes["VodMain"] = 1] = "VodMain";
    MediaImageTypes[MediaImageTypes["ChannelLogoTransparent36"] = 4] = "ChannelLogoTransparent36";
    MediaImageTypes[MediaImageTypes["ChannelLogoWhiteTransparent"] = 8] = "ChannelLogoWhiteTransparent";
    MediaImageTypes[MediaImageTypes["ChannelLogoOriginal"] = 10] = "ChannelLogoOriginal";
    MediaImageTypes[MediaImageTypes["TvProgram"] = 28] = "TvProgram";
    MediaImageTypes[MediaImageTypes["TvProgram16X9"] = 29] = "TvProgram16X9";
    MediaImageTypes[MediaImageTypes["VodGenre"] = 41] = "VodGenre";
    MediaImageTypes[MediaImageTypes["VodGenreMonochrome"] = 42] = "VodGenreMonochrome";
    MediaImageTypes[MediaImageTypes["VodScreenshot"] = 43] = "VodScreenshot";
    MediaImageTypes[MediaImageTypes["VodWallpaper"] = 44] = "VodWallpaper";
    MediaImageTypes[MediaImageTypes["VodCredit"] = 45] = "VodCredit";
    MediaImageTypes[MediaImageTypes["VodPerson"] = 46] = "VodPerson";
    MediaImageTypes[MediaImageTypes["Season"] = 47] = "Season";
    MediaImageTypes[MediaImageTypes["Episode"] = 48] = "Episode";
    MediaImageTypes[MediaImageTypes["TopShelf"] = 49] = "TopShelf";
    MediaImageTypes[MediaImageTypes["Label"] = 50] = "Label";
    MediaImageTypes[MediaImageTypes["VodTopGenrePoster"] = 51] = "VodTopGenrePoster";
    MediaImageTypes[MediaImageTypes["VodTopGenreWallpaper"] = 52] = "VodTopGenreWallpaper";
    MediaImageTypes[MediaImageTypes["StoreProduct"] = 101] = "StoreProduct";
})(MediaImageTypes || (MediaImageTypes = {}));
/**
* Media request types

0 = Internal

1 = GoogleDai
* @format int32
*/
var MediaRequestTypes;
(function (MediaRequestTypes) {
    MediaRequestTypes[MediaRequestTypes["Internal"] = 0] = "Internal";
    MediaRequestTypes[MediaRequestTypes["GoogleDai"] = 1] = "GoogleDai";
})(MediaRequestTypes || (MediaRequestTypes = {}));
/**
* Scope of search of on demand items.

120 = SearchByActors

121 = SearchByDirectors

122 = SearchByName

123 = SearchByDescription

124 = SearchByNameWithGrouping

129 = MoviesOnTv

130 = SportsOnTv

131 = KidsOnTv

132 = NewsOnTv

133 = MoviesOnTvLookback

134 = SportsOnTvLookback

135 = KidsOnTvLookback

136 = NewsOnTvLookback

137 = NewlyReleased

138 = OlympicsOnTv

139 = OlympicsOnTvLookback

140 = Watched

141 = Watching

142 = InternalGenre

143 = TopShelf

144 = WatchingWithGrouping

145 = MostPopularVod

146 = SeriesOnTv

147 = SeriesOnTvLookback

150 = NewStories

151 = SeriesOnTvExcludingKidsSportsNews

152 = SeriesOnTvExcludingKidsSportsNewsLookback

-1 = AllItems
* @format int32
*/
var OnDemandRequestType;
(function (OnDemandRequestType) {
    OnDemandRequestType[OnDemandRequestType["SearchByActors"] = 120] = "SearchByActors";
    OnDemandRequestType[OnDemandRequestType["SearchByDirectors"] = 121] = "SearchByDirectors";
    OnDemandRequestType[OnDemandRequestType["SearchByName"] = 122] = "SearchByName";
    OnDemandRequestType[OnDemandRequestType["SearchByDescription"] = 123] = "SearchByDescription";
    OnDemandRequestType[OnDemandRequestType["SearchByNameWithGrouping"] = 124] = "SearchByNameWithGrouping";
    OnDemandRequestType[OnDemandRequestType["MoviesOnTv"] = 129] = "MoviesOnTv";
    OnDemandRequestType[OnDemandRequestType["SportsOnTv"] = 130] = "SportsOnTv";
    OnDemandRequestType[OnDemandRequestType["KidsOnTv"] = 131] = "KidsOnTv";
    OnDemandRequestType[OnDemandRequestType["NewsOnTv"] = 132] = "NewsOnTv";
    OnDemandRequestType[OnDemandRequestType["MoviesOnTvLookback"] = 133] = "MoviesOnTvLookback";
    OnDemandRequestType[OnDemandRequestType["SportsOnTvLookback"] = 134] = "SportsOnTvLookback";
    OnDemandRequestType[OnDemandRequestType["KidsOnTvLookback"] = 135] = "KidsOnTvLookback";
    OnDemandRequestType[OnDemandRequestType["NewsOnTvLookback"] = 136] = "NewsOnTvLookback";
    OnDemandRequestType[OnDemandRequestType["NewlyReleased"] = 137] = "NewlyReleased";
    OnDemandRequestType[OnDemandRequestType["OlympicsOnTv"] = 138] = "OlympicsOnTv";
    OnDemandRequestType[OnDemandRequestType["OlympicsOnTvLookback"] = 139] = "OlympicsOnTvLookback";
    OnDemandRequestType[OnDemandRequestType["Watched"] = 140] = "Watched";
    OnDemandRequestType[OnDemandRequestType["Watching"] = 141] = "Watching";
    OnDemandRequestType[OnDemandRequestType["InternalGenre"] = 142] = "InternalGenre";
    OnDemandRequestType[OnDemandRequestType["TopShelf"] = 143] = "TopShelf";
    OnDemandRequestType[OnDemandRequestType["WatchingWithGrouping"] = 144] = "WatchingWithGrouping";
    OnDemandRequestType[OnDemandRequestType["MostPopularVod"] = 145] = "MostPopularVod";
    OnDemandRequestType[OnDemandRequestType["SeriesOnTv"] = 146] = "SeriesOnTv";
    OnDemandRequestType[OnDemandRequestType["SeriesOnTvLookback"] = 147] = "SeriesOnTvLookback";
    OnDemandRequestType[OnDemandRequestType["NewStories"] = 150] = "NewStories";
    OnDemandRequestType[OnDemandRequestType["SeriesOnTvExcludingKidsSportsNews"] = 151] = "SeriesOnTvExcludingKidsSportsNews";
    OnDemandRequestType[OnDemandRequestType["SeriesOnTvExcludingKidsSportsNewsLookback"] = 152] = "SeriesOnTvExcludingKidsSportsNewsLookback";
    OnDemandRequestType[OnDemandRequestType["AllItems"] = -1] = "AllItems";
})(OnDemandRequestType || (OnDemandRequestType = {}));
/**
* Payment methods

1 = CreditCard

15 = GooglePay

16 = RokuStore

17 = AmazonStore

18 = AppleStore

19 = AndroidPhoneCreditCard

20 = GoogleInApp
* @format int32
*/
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod[PaymentMethod["CreditCard"] = 1] = "CreditCard";
    PaymentMethod[PaymentMethod["GooglePay"] = 15] = "GooglePay";
    PaymentMethod[PaymentMethod["RokuStore"] = 16] = "RokuStore";
    PaymentMethod[PaymentMethod["AmazonStore"] = 17] = "AmazonStore";
    PaymentMethod[PaymentMethod["AppleStore"] = 18] = "AppleStore";
    PaymentMethod[PaymentMethod["AndroidPhoneCreditCard"] = 19] = "AndroidPhoneCreditCard";
    PaymentMethod[PaymentMethod["GoogleInApp"] = 20] = "GoogleInApp";
})(PaymentMethod || (PaymentMethod = {}));
/**
* The result of operation

1 = Success

3 = ErrorOnCreateProfile

9 = NotUserProfile

10 = NotFoundRiverPackage

11 = ErrorCreateOrder

12 = ErrorProcessPayment

13 = UnknownError

14 = NotFoundAddress

15 = UserHasPackage

16 = ErrorOnPreAuthorization

-5 = VerificationCodeDoesntExist

-4 = NumberAttemptsExceeded

-3 = VerificationCodeDoesntMatch

-1 = AlreadyStarted
* @format int32
*/
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus[PaymentStatus["Success"] = 1] = "Success";
    PaymentStatus[PaymentStatus["ErrorOnCreateProfile"] = 3] = "ErrorOnCreateProfile";
    PaymentStatus[PaymentStatus["NotUserProfile"] = 9] = "NotUserProfile";
    PaymentStatus[PaymentStatus["NotFoundRiverPackage"] = 10] = "NotFoundRiverPackage";
    PaymentStatus[PaymentStatus["ErrorCreateOrder"] = 11] = "ErrorCreateOrder";
    PaymentStatus[PaymentStatus["ErrorProcessPayment"] = 12] = "ErrorProcessPayment";
    PaymentStatus[PaymentStatus["UnknownError"] = 13] = "UnknownError";
    PaymentStatus[PaymentStatus["NotFoundAddress"] = 14] = "NotFoundAddress";
    PaymentStatus[PaymentStatus["UserHasPackage"] = 15] = "UserHasPackage";
    PaymentStatus[PaymentStatus["ErrorOnPreAuthorization"] = 16] = "ErrorOnPreAuthorization";
    PaymentStatus[PaymentStatus["VerificationCodeDoesntExist"] = -5] = "VerificationCodeDoesntExist";
    PaymentStatus[PaymentStatus["NumberAttemptsExceeded"] = -4] = "NumberAttemptsExceeded";
    PaymentStatus[PaymentStatus["VerificationCodeDoesntMatch"] = -3] = "VerificationCodeDoesntMatch";
    PaymentStatus[PaymentStatus["AlreadyStarted"] = -1] = "AlreadyStarted";
})(PaymentStatus || (PaymentStatus = {}));
/**
* Payment type

0 = CreditCard

1 = PaymentProfile
* @format int32
*/
var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["CreditCard"] = 0] = "CreditCard";
    PaymentType[PaymentType["PaymentProfile"] = 1] = "PaymentProfile";
})(PaymentType || (PaymentType = {}));
/**
* Type platform

2 = Roku

3 = Amazon

4 = Apple

5 = Google
* @format int32
*/
var PlatformDeviceType;
(function (PlatformDeviceType) {
    PlatformDeviceType[PlatformDeviceType["Roku"] = 2] = "Roku";
    PlatformDeviceType[PlatformDeviceType["Amazon"] = 3] = "Amazon";
    PlatformDeviceType[PlatformDeviceType["Apple"] = 4] = "Apple";
    PlatformDeviceType[PlatformDeviceType["Google"] = 5] = "Google";
})(PlatformDeviceType || (PlatformDeviceType = {}));
/**
*

0 = Success

-3 = InvalidOperation

-2 = MaxProfileCountExceeded

-1 = AccessIsDenied
* @format int32
*/
var ProfileStatus;
(function (ProfileStatus) {
    ProfileStatus[ProfileStatus["Success"] = 0] = "Success";
    ProfileStatus[ProfileStatus["InvalidOperation"] = -3] = "InvalidOperation";
    ProfileStatus[ProfileStatus["MaxProfileCountExceeded"] = -2] = "MaxProfileCountExceeded";
    ProfileStatus[ProfileStatus["AccessIsDenied"] = -1] = "AccessIsDenied";
})(ProfileStatus || (ProfileStatus = {}));
/**
* Predefined list of possible program types

0 = Unknown

1 = Compilation

2 = Episode

3 = FeatureFilm

4 = Miniseries

5 = PaidProgramming

6 = Preview

7 = SeasonOfASeries

8 = Series

9 = ShortFilm

10 = Special

11 = SportsEvent

12 = SportsNonEvent

13 = TvMovie

14 = TeamEvent

15 = TheatreEvent

16 = Trailer

17 = Highlights

18 = MusicVideo

19 = TBA

20 = OffAir
* @format int32
*/
var ProgramType;
(function (ProgramType) {
    ProgramType[ProgramType["Unknown"] = 0] = "Unknown";
    ProgramType[ProgramType["Compilation"] = 1] = "Compilation";
    ProgramType[ProgramType["Episode"] = 2] = "Episode";
    ProgramType[ProgramType["FeatureFilm"] = 3] = "FeatureFilm";
    ProgramType[ProgramType["Miniseries"] = 4] = "Miniseries";
    ProgramType[ProgramType["PaidProgramming"] = 5] = "PaidProgramming";
    ProgramType[ProgramType["Preview"] = 6] = "Preview";
    ProgramType[ProgramType["SeasonOfASeries"] = 7] = "SeasonOfASeries";
    ProgramType[ProgramType["Series"] = 8] = "Series";
    ProgramType[ProgramType["ShortFilm"] = 9] = "ShortFilm";
    ProgramType[ProgramType["Special"] = 10] = "Special";
    ProgramType[ProgramType["SportsEvent"] = 11] = "SportsEvent";
    ProgramType[ProgramType["SportsNonEvent"] = 12] = "SportsNonEvent";
    ProgramType[ProgramType["TvMovie"] = 13] = "TvMovie";
    ProgramType[ProgramType["TeamEvent"] = 14] = "TeamEvent";
    ProgramType[ProgramType["TheatreEvent"] = 15] = "TheatreEvent";
    ProgramType[ProgramType["Trailer"] = 16] = "Trailer";
    ProgramType[ProgramType["Highlights"] = 17] = "Highlights";
    ProgramType[ProgramType["MusicVideo"] = 18] = "MusicVideo";
    ProgramType[ProgramType["TBA"] = 19] = "TBA";
    ProgramType[ProgramType["OffAir"] = 20] = "OffAir";
})(ProgramType || (ProgramType = {}));
/**
* Deep link provider

1 = Apple

2 = Android

3 = Roku
* @format int32
*/
var Provider;
(function (Provider) {
    Provider[Provider["Apple"] = 1] = "Apple";
    Provider[Provider["Android"] = 2] = "Android";
    Provider[Provider["Roku"] = 3] = "Roku";
})(Provider || (Provider = {}));
/**
* Possible statuses for receipt verification

0 = Ok

1 = InternalError

2 = WrongArgument

3 = IAPVerificationFailed

4 = SubscriptionActivationFailed
* @format int32
*/
var ReceiptVerificationResultStatus;
(function (ReceiptVerificationResultStatus) {
    ReceiptVerificationResultStatus[ReceiptVerificationResultStatus["Ok"] = 0] = "Ok";
    ReceiptVerificationResultStatus[ReceiptVerificationResultStatus["InternalError"] = 1] = "InternalError";
    ReceiptVerificationResultStatus[ReceiptVerificationResultStatus["WrongArgument"] = 2] = "WrongArgument";
    ReceiptVerificationResultStatus[ReceiptVerificationResultStatus["IAPVerificationFailed"] = 3] = "IAPVerificationFailed";
    ReceiptVerificationResultStatus[ReceiptVerificationResultStatus["SubscriptionActivationFailed"] = 4] = "SubscriptionActivationFailed";
})(ReceiptVerificationResultStatus || (ReceiptVerificationResultStatus = {}));
/**
*

1 = Recorded

2 = ToRecord

3 = Any
* @format int32
*/
var RecordingStatus;
(function (RecordingStatus) {
    RecordingStatus[RecordingStatus["Recorded"] = 1] = "Recorded";
    RecordingStatus[RecordingStatus["ToRecord"] = 2] = "ToRecord";
    RecordingStatus[RecordingStatus["Any"] = 3] = "Any";
})(RecordingStatus || (RecordingStatus = {}));
/**
* Represents TvGuide recording type.

1 = Local

2 = VCloud

3 = All
* @format int32
*/
var RecordingType;
(function (RecordingType) {
    RecordingType[RecordingType["Local"] = 1] = "Local";
    RecordingType[RecordingType["VCloud"] = 2] = "VCloud";
    RecordingType[RecordingType["All"] = 3] = "All";
})(RecordingType || (RecordingType = {}));
/**
* LocMedicalRegistrationStatus
IDs according to old RegistrationStatus

1 = Success

-100 = ErrorUnknown

-19 = ErrorAttachDeviceToUser

-11 = ErrorUserExist
* @format int32
*/
var RegistrationByMacStatus;
(function (RegistrationByMacStatus) {
    RegistrationByMacStatus[RegistrationByMacStatus["Success"] = 1] = "Success";
    RegistrationByMacStatus[RegistrationByMacStatus["ErrorUnknown"] = -100] = "ErrorUnknown";
    RegistrationByMacStatus[RegistrationByMacStatus["ErrorAttachDeviceToUser"] = -19] = "ErrorAttachDeviceToUser";
    RegistrationByMacStatus[RegistrationByMacStatus["ErrorUserExist"] = -11] = "ErrorUserExist";
})(RegistrationByMacStatus || (RegistrationByMacStatus = {}));
/**
*

1 = Success

-103 = ErrorUserLoginNotValid

-102 = ErrorUserPasswordNotValid

-101 = ErrorUserLoginExist

-100 = ErrorUnknown

-19 = ErrorAttachDeviceToUser

-17 = ErrorTooManyUsersWithStbMacAddress

-16 = UserNotFound

-15 = UnsupportedCountry

-14 = NoUserName

-13 = ErrorManyUsersWithoutPackages

-12 = ErrorManyUsersWithPackages

-11 = ErrorUserExist

-10 = ErrorSetTrialPackagesForGeoLocation

-9 = ErrorDeviceRegistered

-8 = ErrorCreatingClient

-7 = ErrorAddingPackage

-6 = UnsupportedPlatform

-5 = VerificationCodeDoesntExist

-4 = NumberAttemptsExceeded

-3 = VerificationCodeDoesntMatch

-2 = ErrorTypeProvider

-1 = ErrorSignInToken
* @format int32
*/
var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus[RegistrationStatus["Success"] = 1] = "Success";
    RegistrationStatus[RegistrationStatus["ErrorUserLoginNotValid"] = -103] = "ErrorUserLoginNotValid";
    RegistrationStatus[RegistrationStatus["ErrorUserPasswordNotValid"] = -102] = "ErrorUserPasswordNotValid";
    RegistrationStatus[RegistrationStatus["ErrorUserLoginExist"] = -101] = "ErrorUserLoginExist";
    RegistrationStatus[RegistrationStatus["ErrorUnknown"] = -100] = "ErrorUnknown";
    RegistrationStatus[RegistrationStatus["ErrorAttachDeviceToUser"] = -19] = "ErrorAttachDeviceToUser";
    RegistrationStatus[RegistrationStatus["ErrorTooManyUsersWithStbMacAddress"] = -17] = "ErrorTooManyUsersWithStbMacAddress";
    RegistrationStatus[RegistrationStatus["UserNotFound"] = -16] = "UserNotFound";
    RegistrationStatus[RegistrationStatus["UnsupportedCountry"] = -15] = "UnsupportedCountry";
    RegistrationStatus[RegistrationStatus["NoUserName"] = -14] = "NoUserName";
    RegistrationStatus[RegistrationStatus["ErrorManyUsersWithoutPackages"] = -13] = "ErrorManyUsersWithoutPackages";
    RegistrationStatus[RegistrationStatus["ErrorManyUsersWithPackages"] = -12] = "ErrorManyUsersWithPackages";
    RegistrationStatus[RegistrationStatus["ErrorUserExist"] = -11] = "ErrorUserExist";
    RegistrationStatus[RegistrationStatus["ErrorSetTrialPackagesForGeoLocation"] = -10] = "ErrorSetTrialPackagesForGeoLocation";
    RegistrationStatus[RegistrationStatus["ErrorDeviceRegistered"] = -9] = "ErrorDeviceRegistered";
    RegistrationStatus[RegistrationStatus["ErrorCreatingClient"] = -8] = "ErrorCreatingClient";
    RegistrationStatus[RegistrationStatus["ErrorAddingPackage"] = -7] = "ErrorAddingPackage";
    RegistrationStatus[RegistrationStatus["UnsupportedPlatform"] = -6] = "UnsupportedPlatform";
    RegistrationStatus[RegistrationStatus["VerificationCodeDoesntExist"] = -5] = "VerificationCodeDoesntExist";
    RegistrationStatus[RegistrationStatus["NumberAttemptsExceeded"] = -4] = "NumberAttemptsExceeded";
    RegistrationStatus[RegistrationStatus["VerificationCodeDoesntMatch"] = -3] = "VerificationCodeDoesntMatch";
    RegistrationStatus[RegistrationStatus["ErrorTypeProvider"] = -2] = "ErrorTypeProvider";
    RegistrationStatus[RegistrationStatus["ErrorSignInToken"] = -1] = "ErrorSignInToken";
})(RegistrationStatus || (RegistrationStatus = {}));
/**
* Related channel type

0 = Showtimes
* @format int32
*/
var RelatedChannelType;
(function (RelatedChannelType) {
    RelatedChannelType[RelatedChannelType["Showtimes"] = 0] = "Showtimes";
})(RelatedChannelType || (RelatedChannelType = {}));
/**
*

1 = children

2 = showing

3 = similar

4 = details

5 = IDs

6 = Seasons

7 = CurrentEpisode

8 = Showtimes
* @format int32
*/
var RelatedType;
(function (RelatedType) {
    RelatedType[RelatedType["Children"] = 1] = "Children";
    RelatedType[RelatedType["Showing"] = 2] = "Showing";
    RelatedType[RelatedType["Similar"] = 3] = "Similar";
    RelatedType[RelatedType["Details"] = 4] = "Details";
    RelatedType[RelatedType["IDs"] = 5] = "IDs";
    RelatedType[RelatedType["Seasons"] = 6] = "Seasons";
    RelatedType[RelatedType["CurrentEpisode"] = 7] = "CurrentEpisode";
    RelatedType[RelatedType["Showtimes"] = 8] = "Showtimes";
})(RelatedType || (RelatedType = {}));
/**
* Profile types (see more [here](http://atlassian.vmedia.loc:8070/display/VW/User+profiles#Userprofiles-ProfileTypes))

1 = Adult

2 = Teens

3 = Kids

4 = Toddlers
* @format int32
*/
var RestrictionType;
(function (RestrictionType) {
    RestrictionType[RestrictionType["Adult"] = 1] = "Adult";
    RestrictionType[RestrictionType["Teens"] = 2] = "Teens";
    RestrictionType[RestrictionType["Kids"] = 3] = "Kids";
    RestrictionType[RestrictionType["Toddlers"] = 4] = "Toddlers";
})(RestrictionType || (RestrictionType = {}));
/**
* River registration type.

0 = Default

1 = VerificationByEmail

2 = ByStbMacAddress

3 = VerificationByEmailIncludingUserPasswordUserLogin
* @format int32
*/
var RiverRegistrationType;
(function (RiverRegistrationType) {
    RiverRegistrationType[RiverRegistrationType["Default"] = 0] = "Default";
    RiverRegistrationType[RiverRegistrationType["VerificationByEmail"] = 1] = "VerificationByEmail";
    RiverRegistrationType[RiverRegistrationType["ByStbMacAddress"] = 2] = "ByStbMacAddress";
    RiverRegistrationType[RiverRegistrationType["VerificationByEmailIncludingUserPasswordUserLogin"] = 3] = "VerificationByEmailIncludingUserPasswordUserLogin";
})(RiverRegistrationType || (RiverRegistrationType = {}));
/**
* Response statuses on river packages methods

0 = SessionError

1 = PackageAssigned

2 = WarningOutsideNetwork

3 = Success

4 = TransactionNotFound

5 = ErrorRokuCancel

6 = HasActivePackage
* @format int32
*/
var RiverStatus;
(function (RiverStatus) {
    RiverStatus[RiverStatus["SessionError"] = 0] = "SessionError";
    RiverStatus[RiverStatus["PackageAssigned"] = 1] = "PackageAssigned";
    RiverStatus[RiverStatus["WarningOutsideNetwork"] = 2] = "WarningOutsideNetwork";
    RiverStatus[RiverStatus["Success"] = 3] = "Success";
    RiverStatus[RiverStatus["TransactionNotFound"] = 4] = "TransactionNotFound";
    RiverStatus[RiverStatus["ErrorRokuCancel"] = 5] = "ErrorRokuCancel";
    RiverStatus[RiverStatus["HasActivePackage"] = 6] = "HasActivePackage";
})(RiverStatus || (RiverStatus = {}));
/**
* Status of verification code sending

1 = Success

2 = AttemptLimit

3 = Failed

4 = EmailIsBusy
* @format int32
*/
var SendVerifyCodeStatus;
(function (SendVerifyCodeStatus) {
    SendVerifyCodeStatus[SendVerifyCodeStatus["Success"] = 1] = "Success";
    SendVerifyCodeStatus[SendVerifyCodeStatus["AttemptLimit"] = 2] = "AttemptLimit";
    SendVerifyCodeStatus[SendVerifyCodeStatus["Failed"] = 3] = "Failed";
    SendVerifyCodeStatus[SendVerifyCodeStatus["EmailIsBusy"] = 4] = "EmailIsBusy";
})(SendVerifyCodeStatus || (SendVerifyCodeStatus = {}));
/**
* Type Internet

0 = Unknown

1 = Partner

2 = VMedia
* @format int32
*/
var ServiceProviderType;
(function (ServiceProviderType) {
    ServiceProviderType[ServiceProviderType["Unknown"] = 0] = "Unknown";
    ServiceProviderType[ServiceProviderType["Partner"] = 1] = "Partner";
    ServiceProviderType[ServiceProviderType["VMedia"] = 2] = "VMedia";
})(ServiceProviderType || (ServiceProviderType = {}));
/**
* Show type of item

0 = None

1 = Movie

2 = Series

4 = Special
* @format int32
*/
var ShowTypes;
(function (ShowTypes) {
    ShowTypes[ShowTypes["None"] = 0] = "None";
    ShowTypes[ShowTypes["Movie"] = 1] = "Movie";
    ShowTypes[ShowTypes["Series"] = 2] = "Series";
    ShowTypes[ShowTypes["Special"] = 4] = "Special";
})(ShowTypes || (ShowTypes = {}));
/**
* Predefined list of possible subscription service statuses

1 = Available

2 = Enabled

3 = NA

4 = PreviewAvailable
* @format int32
*/
var Status;
(function (Status) {
    Status[Status["Available"] = 1] = "Available";
    Status[Status["Enabled"] = 2] = "Enabled";
    Status[Status["NA"] = 3] = "NA";
    Status[Status["PreviewAvailable"] = 4] = "PreviewAvailable";
})(Status || (Status = {}));
/**
* Stream quality enum SQ,HQ...

0 = VQ

1 = SQ

2 = HQ

3 = GQ

4 = EQ

5 = BQ
* @format int32
*/
var StreamQualityPreset;
(function (StreamQualityPreset) {
    StreamQualityPreset[StreamQualityPreset["VQ"] = 0] = "VQ";
    StreamQualityPreset[StreamQualityPreset["SQ"] = 1] = "SQ";
    StreamQualityPreset[StreamQualityPreset["HQ"] = 2] = "HQ";
    StreamQualityPreset[StreamQualityPreset["GQ"] = 3] = "GQ";
    StreamQualityPreset[StreamQualityPreset["EQ"] = 4] = "EQ";
    StreamQualityPreset[StreamQualityPreset["BQ"] = 5] = "BQ";
})(StreamQualityPreset || (StreamQualityPreset = {}));
/**
* Token source

1 = Amazon

2 = Google

3 = Apple
* @format int32
*/
var TokenProvider;
(function (TokenProvider) {
    TokenProvider[TokenProvider["Amazon"] = 1] = "Amazon";
    TokenProvider[TokenProvider["Google"] = 2] = "Google";
    TokenProvider[TokenProvider["Apple"] = 3] = "Apple";
})(TokenProvider || (TokenProvider = {}));
/**
* Status result for validation transaction

1 = AlreadySubscribed

2 = Success

3 = InternalError

4 = TaxNotFound

5 = ReceiptExpired

6 = AlreadyStarted

7 = ErrorCreateOrder

8 = NeedSetupPackage

9 = ExternalPackageDoesntEqual

10 = DontHaveLatestReceiptInfo

11 = TransactionAlreadyUsedAnotherAccount

12 = ExternalPackageHaveNotPackageId
* @format int32
*/
var TransactionValidationStatus;
(function (TransactionValidationStatus) {
    TransactionValidationStatus[TransactionValidationStatus["AlreadySubscribed"] = 1] = "AlreadySubscribed";
    TransactionValidationStatus[TransactionValidationStatus["Success"] = 2] = "Success";
    TransactionValidationStatus[TransactionValidationStatus["InternalError"] = 3] = "InternalError";
    TransactionValidationStatus[TransactionValidationStatus["TaxNotFound"] = 4] = "TaxNotFound";
    TransactionValidationStatus[TransactionValidationStatus["ReceiptExpired"] = 5] = "ReceiptExpired";
    TransactionValidationStatus[TransactionValidationStatus["AlreadyStarted"] = 6] = "AlreadyStarted";
    TransactionValidationStatus[TransactionValidationStatus["ErrorCreateOrder"] = 7] = "ErrorCreateOrder";
    TransactionValidationStatus[TransactionValidationStatus["NeedSetupPackage"] = 8] = "NeedSetupPackage";
    TransactionValidationStatus[TransactionValidationStatus["ExternalPackageDoesntEqual"] = 9] = "ExternalPackageDoesntEqual";
    TransactionValidationStatus[TransactionValidationStatus["DontHaveLatestReceiptInfo"] = 10] = "DontHaveLatestReceiptInfo";
    TransactionValidationStatus[TransactionValidationStatus["TransactionAlreadyUsedAnotherAccount"] = 11] = "TransactionAlreadyUsedAnotherAccount";
    TransactionValidationStatus[TransactionValidationStatus["ExternalPackageHaveNotPackageId"] = 12] = "ExternalPackageHaveNotPackageId";
})(TransactionValidationStatus || (TransactionValidationStatus = {}));
/**
* Response statuses on trial packages methods

0 = SessionError

1 = ErrorHadTrial

2 = WarningOutsideNetwork

3 = Success

4 = PackageNotAvailable

5 = PackageAssigned

6 = TransactionNotFound

7 = ErrorRokuCancel

8 = NoCreditCard

9 = NotFoundUserServiceAddress
* @format int32
*/
var TrialStatus;
(function (TrialStatus) {
    TrialStatus[TrialStatus["SessionError"] = 0] = "SessionError";
    TrialStatus[TrialStatus["ErrorHadTrial"] = 1] = "ErrorHadTrial";
    TrialStatus[TrialStatus["WarningOutsideNetwork"] = 2] = "WarningOutsideNetwork";
    TrialStatus[TrialStatus["Success"] = 3] = "Success";
    TrialStatus[TrialStatus["PackageNotAvailable"] = 4] = "PackageNotAvailable";
    TrialStatus[TrialStatus["PackageAssigned"] = 5] = "PackageAssigned";
    TrialStatus[TrialStatus["TransactionNotFound"] = 6] = "TransactionNotFound";
    TrialStatus[TrialStatus["ErrorRokuCancel"] = 7] = "ErrorRokuCancel";
    TrialStatus[TrialStatus["NoCreditCard"] = 8] = "NoCreditCard";
    TrialStatus[TrialStatus["NotFoundUserServiceAddress"] = 9] = "NotFoundUserServiceAddress";
})(TrialStatus || (TrialStatus = {}));
/**
* Restrictions for a media stream.

0 = None

1 = FastForward

2 = Rewind

4 = Pause
* @format int32
*/
var TrickModeRestriction;
(function (TrickModeRestriction) {
    TrickModeRestriction[TrickModeRestriction["None"] = 0] = "None";
    TrickModeRestriction[TrickModeRestriction["FastForward"] = 1] = "FastForward";
    TrickModeRestriction[TrickModeRestriction["Rewind"] = 2] = "Rewind";
    TrickModeRestriction[TrickModeRestriction["Pause"] = 4] = "Pause";
})(TrickModeRestriction || (TrickModeRestriction = {}));
/**
* Tv Qualifier

6 = Cc

12 = Dvs

35 = SubTitled
* @format int32
*/
var TvQualifier;
(function (TvQualifier) {
    TvQualifier[TvQualifier["Cc"] = 6] = "Cc";
    TvQualifier[TvQualifier["Dvs"] = 12] = "Dvs";
    TvQualifier[TvQualifier["SubTitled"] = 35] = "SubTitled";
})(TvQualifier || (TvQualifier = {}));
/**
* Application update requirements type

0 = None

1 = Recommended

2 = Required

-1 = InvalidVersion
* @format int32
*/
var UpdateRequirementsType;
(function (UpdateRequirementsType) {
    UpdateRequirementsType[UpdateRequirementsType["None"] = 0] = "None";
    UpdateRequirementsType[UpdateRequirementsType["Recommended"] = 1] = "Recommended";
    UpdateRequirementsType[UpdateRequirementsType["Required"] = 2] = "Required";
    UpdateRequirementsType[UpdateRequirementsType["InvalidVersion"] = -1] = "InvalidVersion";
})(UpdateRequirementsType || (UpdateRequirementsType = {}));
/**
* Represents result of sending verification code.

1 = Success

2 = BelongToUser

3 = Error

4 = ErrorOnSentSms
* @format int32
*/
var VerificationCodeStatus;
(function (VerificationCodeStatus) {
    VerificationCodeStatus[VerificationCodeStatus["Success"] = 1] = "Success";
    VerificationCodeStatus[VerificationCodeStatus["BelongToUser"] = 2] = "BelongToUser";
    VerificationCodeStatus[VerificationCodeStatus["Error"] = 3] = "Error";
    VerificationCodeStatus[VerificationCodeStatus["ErrorOnSentSms"] = 4] = "ErrorOnSentSms";
})(VerificationCodeStatus || (VerificationCodeStatus = {}));
/**
* Scope of search of Video on demand types

0 = All

1 = VOD

2 = SVOD

3 = PPV

4 = CraveTV
* @format int32
*/
var VodType;
(function (VodType) {
    VodType[VodType["All"] = 0] = "All";
    VodType[VodType["VOD"] = 1] = "VOD";
    VodType[VodType["SVOD"] = 2] = "SVOD";
    VodType[VodType["PPV"] = 3] = "PPV";
    VodType[VodType["CraveTV"] = 4] = "CraveTV";
})(VodType || (VodType = {}));
/**
*

1 = Keyword

11 = String

12 = Number

51 = Genre

52 = ContentType

53 = Channel

54 = Container

55 = Program

56 = Schedule

57 = Movie

101 = Application
* @format int32
*/
var WordGroupType;
(function (WordGroupType) {
    WordGroupType[WordGroupType["Keyword"] = 1] = "Keyword";
    WordGroupType[WordGroupType["String"] = 11] = "String";
    WordGroupType[WordGroupType["Number"] = 12] = "Number";
    WordGroupType[WordGroupType["Genre"] = 51] = "Genre";
    WordGroupType[WordGroupType["ContentType"] = 52] = "ContentType";
    WordGroupType[WordGroupType["Channel"] = 53] = "Channel";
    WordGroupType[WordGroupType["Container"] = 54] = "Container";
    WordGroupType[WordGroupType["Program"] = 55] = "Program";
    WordGroupType[WordGroupType["Schedule"] = 56] = "Schedule";
    WordGroupType[WordGroupType["Movie"] = 57] = "Movie";
    WordGroupType[WordGroupType["Application"] = 101] = "Application";
})(WordGroupType || (WordGroupType = {}));
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(ContentType || (ContentType = {}));
class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) && this.securityWorker && (await this.securityWorker(this.securityData))) || {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
/**
 * @title Futhark API
 * @version 1.0
 */
class Api extends HttpClient {
    api = {
        /**
         * No description
         *
         * @tags Channel
         * @name ChannelClientCreate
         * @summary Returns channels for specific session ID
         * @request POST:/api/channel/client
         * @response `200` `Channels` Channel list
         */
        channelClientCreate: (data, params = {}) => this.request({
            path: `/api/channel/client`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Channel
         * @name ChannelAppCreate
         * @summary Returns channels for specific side ID, application name and country
         * @request POST:/api/channel/app
         * @response `200` `Channels` Channel list
         */
        channelAppCreate: (data, params = {}) => this.request({
            path: `/api/channel/app`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Channel
         * @name ChannelClientrelatedCreate
         * @summary Returns client related channels
         * @request POST:/api/channel/clientrelated
         * @response `200` `Channels` Channel list
         */
        channelClientrelatedCreate: (data, params = {}) => this.request({
            path: `/api/channel/clientrelated`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Channel
         * @name ChannelApprelatedCreate
         * @summary Returns app related channels
         * @request POST:/api/channel/apprelated
         * @response `200` `Channels` Channel list
         */
        channelApprelatedCreate: (data, params = {}) => this.request({
            path: `/api/channel/apprelated`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Channel
         * @name ChannelRecentCreate
         * @summary Returns array of recent channels' IDs of a user by session ID
         * @request POST:/api/channel/recent
         * @response `200` `RecentChannel` OK
         */
        channelRecentCreate: (data, params = {}) => this.request({
            path: `/api/channel/recent`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Channel
         * @name ChannelAmazonList
         * @summary Returns array of channels' IDs for synchronization with amazon
         * @request GET:/api/channel/amazon
         * @response `200` `AmazonChannelsResponse` OK
         */
        channelAmazonList: (params = {}) => this.request({
            path: `/api/channel/amazon`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Checkout
         * @name CheckoutClientTypeCreate
         * @summary Returns the checkout type on the session based request
         * @request POST:/api/checkout/client/type
         * @response `200` `DeviceCheckoutType` OK
         */
        checkoutClientTypeCreate: (data, params = {}) => this.request({
            path: `/api/checkout/client/type`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Checkout
         * @name CheckoutClientPackagesCreate
         * @summary Returns TV packages of a user by session based request
         * @request POST:/api/checkout/client/packages
         * @response `200` `(Package)[]` OK
         */
        checkoutClientPackagesCreate: (data, params = {}) => this.request({
            path: `/api/checkout/client/packages`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Checkout
         * @name CheckoutAppPackagesCreate
         * @summary Returns TV packages by IP address
         * @request POST:/api/checkout/app/packages
         * @response `200` `(Package)[]` OK
         */
        checkoutAppPackagesCreate: (data, params = {}) => this.request({
            path: `/api/checkout/app/packages`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Checkout
         * @name CheckoutAppleVerifyReceiptCreate
         * @summary Verifies Apple receipt and activates subscription for a user
         * @request POST:/api/checkout/apple/verifyReceipt
         * @response `200` `ReceiptVerificationResult` OK
         */
        checkoutAppleVerifyReceiptCreate: (data, params = {}) => this.request({
            path: `/api/checkout/apple/verifyReceipt`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientLoginCreate
         * @summary Makes login of a user
         * @request POST:/api/client/login
         * @response `200` `ClientAppSettings` Client app settings
         */
        clientLoginCreate: (data, params = {}) => this.request({
            path: `/api/client/login`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientJwtloginCreate
         * @summary Makes login of a user by jwt token
         * @request POST:/api/client/jwtlogin
         * @response `200` `ClientAppSettings` Client app settings
         */
        clientJwtloginCreate: (data, params = {}) => this.request({
            path: `/api/client/jwtlogin`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientSettingsOktaList
         * @summary Gets the Okta settings.
         * @request GET:/api/client/settings/okta
         * @response `200` `OktaSettings` Get Okta settings
         */
        clientSettingsOktaList: (params = {}) => this.request({
            path: `/api/client/settings/okta`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientLoginOktaCreate
         * @summary Login by Okta token
         * @request POST:/api/client/login/okta
         * @response `200` `OktaClientAppSettings` Client app settings
         */
        clientLoginOktaCreate: (data, params = {}) => this.request({
            path: `/api/client/login/okta`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientLogoutOktaCreate
         * @summary Logout with Okta token
         * @request POST:/api/client/logout/okta
         * @response `200` `boolean` OK
         */
        clientLogoutOktaCreate: (data, params = {}) => this.request({
            path: `/api/client/logout/okta`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientVerificationTokenList
         * @summary Gets the verification token.
         * @request GET:/api/client/verificationToken
         * @response `200` `string` Get verification token for SSO
         */
        clientVerificationTokenList: (params = {}) => this.request({
            path: `/api/client/verificationToken`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientGetsettingsCreate
         * @summary Retuns current user's setting by session ID
         * @request POST:/api/client/getsettings
         * @response `200` `ClientSettings` OK
         */
        clientGetsettingsCreate: (data, params = {}) => this.request({
            path: `/api/client/getsettings`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientSetsettingsCreate
         * @summary Sets specified settings to a user
         * @request POST:/api/client/setsettings
         * @response `200` `boolean` OK
         */
        clientSetsettingsCreate: (data, params = {}) => this.request({
            path: `/api/client/setsettings`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientLogoutCreate
         * @summary Makes logout of a user
         * @request POST:/api/client/logout
         * @response `200` `boolean` OK
         */
        clientLogoutCreate: (data, params = {}) => this.request({
            path: `/api/client/logout`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientMessagesGetCreate
         * @summary Returns messages addressed to a user
         * @request POST:/api/client/messages/get
         * @response `200` `(ClientMessage)[]` OK
         */
        clientMessagesGetCreate: (data, params = {}) => this.request({
            path: `/api/client/messages/get`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientMessagesMarkreadCreate
         * @summary Marks the messages addressed to a user as read by session based request
         * @request POST:/api/client/messages/markread
         * @response `200` `boolean` OK
         */
        clientMessagesMarkreadCreate: (data, params = {}) => this.request({
            path: `/api/client/messages/markread`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientDevicesettingsCreate
         * @summary Provides location, watching area and language of a user by IP address
         * @request POST:/api/client/devicesettings
         * @response `200` `DeviceSettings` OK
         */
        clientDevicesettingsCreate: (query, params = {}) => this.request({
            path: `/api/client/devicesettings`,
            method: "POST",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientDevicesettingsList
         * @summary Provides location, watching area and language of a user by IP address
         * @request GET:/api/client/devicesettings
         * @response `200` `DeviceSettings` OK
         */
        clientDevicesettingsList: (query, params = {}) => this.request({
            path: `/api/client/devicesettings`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientDevicesettingsCreate2
         * @summary Provides location, watching area and language of a user by MAC address
         * @request POST:/api/client/devicesettings/{lang}
         * @originalName clientDevicesettingsCreate
         * @duplicate
         * @response `200` `DeviceSettings` OK
         */
        clientDevicesettingsCreate2: ({ lang, ...query }, data, params = {}) => this.request({
            path: `/api/client/devicesettings/${lang}`,
            method: "POST",
            query: query,
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientDevicesettingsDetail
         * @summary Provides location, watching area and language of a user by MAC address
         * @request GET:/api/client/devicesettings/{lang}
         * @response `200` `DeviceSettings` OK
         */
        clientDevicesettingsDetail: ({ lang, ...query }, data, params = {}) => this.request({
            path: `/api/client/devicesettings/${lang}`,
            method: "GET",
            query: query,
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientPlayeridCreate
         * @summary Get user player id
         * @request POST:/api/client/playerid
         * @response `200` `string` OK
         */
        clientPlayeridCreate: (data, params = {}) => this.request({
            path: `/api/client/playerid`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientDeviceInfoSaveCreate
         * @summary Save device info to cache
         * @request POST:/api/client/deviceInfo/save
         * @response `200` `void` OK
         */
        clientDeviceInfoSaveCreate: (data, params = {}) => this.request({
            path: `/api/client/deviceInfo/save`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientVerificationCodeGetCreate
         * @summary Get verification code
         * @request POST:/api/client/verification-code/get
         * @response `200` `GetVerificationCodeResponse` OK
         * @response `500` `ApiResult` Internal Server Error
         */
        clientVerificationCodeGetCreate: (data, params = {}) => this.request({
            path: `/api/client/verification-code/get`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientVerificationCodeCheckCreate
         * @summary Validate verification code
         * @request POST:/api/client/verification-code/check
         * @response `200` `ApiResult` Validate verification code
         */
        clientVerificationCodeCheckCreate: (data, params = {}) => this.request({
            path: `/api/client/verification-code/check`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientSecureCreate
         * @summary Secure certificates
         * @request POST:/api/client/secure
         * @response `200` `string` Secure string of certificate archive
         */
        clientSecureCreate: (data, params = {}) => this.request({
            path: `/api/client/secure`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientCheckoutCreate
         * @summary Stub for legacy checkout
         * @request POST:/api/client/checkout
         * @response `200` `void` OK
         */
        clientCheckoutCreate: (params = {}) => this.request({
            path: `/api/client/checkout`,
            method: "POST",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientCheckoutList
         * @summary Stub for legacy checkout
         * @request GET:/api/client/checkout
         * @response `200` `void` OK
         */
        clientCheckoutList: (params = {}) => this.request({
            path: `/api/client/checkout`,
            method: "GET",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientRateAppCheckCreate
         * @summary Check if user need rate app in store
         * @request POST:/api/client/rate-app/check
         * @response `200` `BooleanSimpleResponse` OK
         */
        clientRateAppCheckCreate: (data, params = {}) => this.request({
            path: `/api/client/rate-app/check`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientRateAppUpdateCreate
         * @summary Update data of last offer to rate app in store
         * @request POST:/api/client/rate-app/update
         * @response `200` `void` OK
         */
        clientRateAppUpdateCreate: (data, params = {}) => this.request({
            path: `/api/client/rate-app/update`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientUiSettingsGetCreate
         * @summary Get UI settings
         * @request POST:/api/client/ui-settings/get
         * @response `200` `(UiComponent)[]` OK
         */
        clientUiSettingsGetCreate: (data, params = {}) => this.request({
            path: `/api/client/ui-settings/get`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientUiSettingsUpdateCreate
         * @summary Update UI settings
         * @request POST:/api/client/ui-settings/update
         * @response `200` `void` OK
         */
        clientUiSettingsUpdateCreate: (data, params = {}) => this.request({
            path: `/api/client/ui-settings/update`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientTokenGetCreate
         * @summary Get hash from user login and date of generation hash
         * @request POST:/api/client/token/get
         * @response `200` `string` OK
         */
        clientTokenGetCreate: (data, params = {}) => this.request({
            path: `/api/client/token/get`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientSettingsExternalCreate
         * @summary Set External Setting
         * @request POST:/api/client/settings/external
         * @response `200` `DateTimeSimpleResponse` OK
         */
        clientSettingsExternalCreate: (data, params = {}) => this.request({
            path: `/api/client/settings/external`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientSettingsExternalDetail
         * @summary Get External Setting
         * @request GET:/api/client/settings/external/{sessionId}
         * @response `200` `StringSimpleResponse` OK
         */
        clientSettingsExternalDetail: (sessionId, params = {}) => this.request({
            path: `/api/client/settings/external/${sessionId}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client
         * @name ClientRegisterByMacLocmedicalCreate
         * @summary Register LocMedical user by MAC address and assign hospital-specific package
         * @request POST:/api/client/register/by-mac/locmedical
         * @response `200` `RegistrationByMacResponse` Register user for LocMedical by MAC
         * @response `201` `RegistrationByMacResponse` Created
         * @response `400` `ValidationProblemDetails` Bad Request
         * @response `409` `RegistrationByMacResponse` Conflict
         * @response `500` `RegistrationByMacResponse` Internal Server Error
         */
        clientRegisterByMacLocmedicalCreate: (data, params = {}) => this.request({
            path: `/api/client/register/by-mac/locmedical`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Client2
         * @name V2ClientMessagesGetCreate
         * @summary Returns messages addressed to a user
         * @request POST:/api/v2/client/messages/get
         * @response `200` `(ClientMessage)[]` OK
         */
        v2ClientMessagesGetCreate: (data, params = {}) => this.request({
            path: `/api/v2/client/messages/get`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentItempropertiesCreate
         * @summary Returns specified properties of certain items of the content type
         * @request POST:/api/content/itemproperties
         * @response `200` `(ItemProperties)[]` OK
         */
        contentItempropertiesCreate: (data, params = {}) => this.request({
            path: `/api/content/itemproperties`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentStreamprogressCreate
         * @summary Sets specified position in seconds from the beginning of the stream (property "pos")
         * @request POST:/api/content/streamprogress
         * @response `200` `boolean` OK
         */
        contentStreamprogressCreate: (data, params = {}) => this.request({
            path: `/api/content/streamprogress`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentRecordprogramCreate
         * @summary Marks program as one to be recorded either locally or in VCloud
         * @request POST:/api/content/recordprogram
         * @response `200` `boolean` Success
         */
        contentRecordprogramCreate: (data, params = {}) => this.request({
            path: `/api/content/recordprogram`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentRecordprogramobsoleteCreate
         * @summary Marks program as one to be recorded in VCloud
         * @request POST:/api/content/recordprogramobsolete
         * @response `200` `boolean` OK
         */
        contentRecordprogramobsoleteCreate: (data, params = {}) => this.request({
            path: `/api/content/recordprogramobsolete`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentProgramstorecordCreate
         * @summary Returns list of programs set to record no matter if the programs are already recorded
         * @request POST:/api/content/programstorecord
         * @response `200` `(number)[]` OK
         */
        contentProgramstorecordCreate: (data, params = {}) => this.request({
            path: `/api/content/programstorecord`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentRecordchannelsCreate
         * @summary Marks array of channels to be recorded by session based request
         * @request POST:/api/content/recordchannels
         * @response `200` `(KeyValue)[]` OK
         */
        contentRecordchannelsCreate: (data, params = {}) => this.request({
            path: `/api/content/recordchannels`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentRateCreate
         * @summary Rates the specified item
         * @request POST:/api/content/rate
         * @response `200` `number` OK
         */
        contentRateCreate: (data, params = {}) => this.request({
            path: `/api/content/rate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentContributionsCreate
         * @summary Gets contributors for a specified item. Obsolete, use api/content/credits/client
         * @request POST:/api/content/contributions
         * @deprecated
         * @response `200` `(Contribution)[]` OK
         */
        contentContributionsCreate: (data, params = {}) => this.request({
            path: `/api/content/contributions`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentCreditsClientCreate
         * @summary Gets credits for the item for session based request. Obsolete, use api/credit/app
         * @request POST:/api/content/credits/client
         * @deprecated
         * @response `200` `ProtoItemCredits` OK
         */
        contentCreditsClientCreate: (data, params = {}) => this.request({
            path: `/api/content/credits/client`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentCreditsAppCreate
         * @summary Gets credits for the item for app based request. Obsolete, use api/credit/app
         * @request POST:/api/content/credits/app
         * @deprecated
         * @response `200` `ProtoItemCredits` OK
         */
        contentCreditsAppCreate: (data, params = {}) => this.request({
            path: `/api/content/credits/app`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentMarkaswatchedCreate
         * @summary Marks an item of the specified type as watched (property "wat")
         * @request POST:/api/content/markaswatched
         * @response `200` `BooleanSimpleResponse` OK
         */
        contentMarkaswatchedCreate: (data, params = {}) => this.request({
            path: `/api/content/markaswatched`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentSearchCreate
         * @summary Searches for specific content using content filter on the session based request
         * @request POST:/api/content/search
         * @response `200` `MixedContent` OK
         */
        contentSearchCreate: (data, params = {}) => this.request({
            path: `/api/content/search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Returns Operation result - amount of the items with changed properties ("pos")
         *
         * @tags Content
         * @name ContentSetwatchedpositionsCreate
         * @summary Sets watched positions to the array of items
         * @request POST:/api/content/setwatchedpositions
         * @response `200` `Int32OperationResult` OK
         */
        contentSetwatchedpositionsCreate: (data, params = {}) => this.request({
            path: `/api/content/setwatchedpositions`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentSetwatchedrangeCreate
         * @summary Set item watched range
         * @request POST:/api/content/setwatchedrange
         * @response `200` `void` OK
         */
        contentSetwatchedrangeCreate: (data, params = {}) => this.request({
            path: `/api/content/setwatchedrange`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentGetwatchedrangeCreate
         * @summary Gets item watched ranges
         * @request POST:/api/content/getwatchedrange
         * @response `200` `RangeListSimpleResponse` OK
         */
        contentGetwatchedrangeCreate: (data, params = {}) => this.request({
            path: `/api/content/getwatchedrange`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentPopularWordsCreate
         * @summary Search most popular words by keyword
         * @request POST:/api/content/popular-words
         * @response `200` `StringListSimpleResponse` OK
         */
        contentPopularWordsCreate: (data, params = {}) => this.request({
            path: `/api/content/popular-words`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentPopularMixedItemsClientCreate
         * @summary Get most popular vod and vcloud items content for client
         * @request POST:/api/content/popular-mixed-items/client
         * @response `200` `(ProgramGuideItem)[]` Popular mixed items for client mode
         */
        contentPopularMixedItemsClientCreate: (data, params = {}) => this.request({
            path: `/api/content/popular-mixed-items/client`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Content
         * @name ContentPopularMixedItemsAppCreate
         * @summary Get most popular vod and vcloud items content for app
         * @request POST:/api/content/popular-mixed-items/app
         * @response `200` `(ProgramGuideItem)[]` Popular mixed items for guest mode
         */
        contentPopularMixedItemsAppCreate: (data, params = {}) => this.request({
            path: `/api/content/popular-mixed-items/app`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Credit
         * @name CreditAppCreate
         * @summary Gets gracenote credits for the item for session based request.
         * @request POST:/api/credit/app
         * @response `200` `ProtoItemCredits` Credits for title
         */
        creditAppCreate: (data, params = {}) => this.request({
            path: `/api/credit/app`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Credit
         * @name CreditMediographyClientCreate
         * @summary Return person mediography
         * @request POST:/api/credit/mediography/client
         * @response `200` `Mediography` OK
         */
        creditMediographyClientCreate: (data, params = {}) => this.request({
            path: `/api/credit/mediography/client`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Credit
         * @name CreditMediographyAppCreate
         * @summary Return person mediography
         * @request POST:/api/credit/mediography/app
         * @response `200` `Mediography` OK
         */
        creditMediographyAppCreate: (data, params = {}) => this.request({
            path: `/api/credit/mediography/app`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Credit
         * @name CreditPersonSearchRelatedCreate
         * @summary Get persons for People also search row
         * @request POST:/api/credit/person/search-related
         * @response `200` `ProtoItemCredits` OK
         */
        creditPersonSearchRelatedCreate: (data, params = {}) => this.request({
            path: `/api/credit/person/search-related`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Credit
         * @name CreditSearchCreate
         * @summary Search gracenote credits by keyword.
         * @request POST:/api/credit/search
         * @response `200` `SearchCreditsResponse` Credits by keyword
         */
        creditSearchCreate: (data, params = {}) => this.request({
            path: `/api/credit/search`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description For each item in array returns its ID and Content type. Favorites are stored in Redis.
         *
         * @tags Favorites
         * @name FavoritesGetCreate
         * @summary Returns an array of items of the specified content type added to Favorites for displaying in MyTV section
         * @request POST:/api/favorites/get
         * @response `200` `(ProtoItem)[]` OK
         */
        favoritesGetCreate: (data, params = {}) => this.request({
            path: `/api/favorites/get`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Favorites are stored in Redis.
         *
         * @tags Favorites
         * @name FavoritesAddCreate
         * @summary Adds an array of items of the specified type to Favorites
         * @request POST:/api/favorites/add
         * @response `200` `number` OK
         */
        favoritesAddCreate: (data, params = {}) => this.request({
            path: `/api/favorites/add`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Favorites are stored in Redis.
         *
         * @tags Favorites
         * @name FavoritesDeleteCreate
         * @summary Deletes an array of items of the specified type from Favorites
         * @request POST:/api/favorites/delete
         * @response `200` `number` OK
         */
        favoritesDeleteCreate: (data, params = {}) => this.request({
            path: `/api/favorites/delete`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Returns schedules added to Favorites for DVR with the content type = 1. Favorites are stored in Redis.
         *
         * @tags Favorites
         * @name FavoritesProgramsCreate
         * @summary Adds an array of schedules to Favorites in MyTV section
         * @request POST:/api/favorites/programs
         * @response `200` `ProgramGuide` Favorite items
         */
        favoritesProgramsCreate: (data, params = {}) => this.request({
            path: `/api/favorites/programs`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description For each item in array returns its ID and Content type. Favorites are stored in Redis.
         *
         * @tags Favorites2
         * @name V2FavoritesGetCreate
         * @summary Returns an array of items of the specified content type added to Favorites for displaying in MyTV section
         * @request POST:/api/v2/favorites/get
         * @response `200` `(ProtoItem)[]` OK
         */
        v2FavoritesGetCreate: (data, params = {}) => this.request({
            path: `/api/v2/favorites/get`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Favorites are stored in Redis.
         *
         * @tags Favorites2
         * @name V2FavoritesAddCreate
         * @summary Adds an array of items of the specified type to Favorites
         * @request POST:/api/v2/favorites/add
         * @response `200` `number` OK
         */
        v2FavoritesAddCreate: (data, params = {}) => this.request({
            path: `/api/v2/favorites/add`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Favorites are stored in Redis.
         *
         * @tags Favorites2
         * @name V2FavoritesDeleteCreate
         * @summary Deletes an array of items of the specified type from Favorites
         * @request POST:/api/v2/favorites/delete
         * @response `200` `number` OK
         */
        v2FavoritesDeleteCreate: (data, params = {}) => this.request({
            path: `/api/v2/favorites/delete`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Returns schedules added to Favorites for DVR with the content type = 1. Favorites are stored in Redis.
         *
         * @tags Favorites2
         * @name V2FavoritesProgramsCreate
         * @summary Adds an array of schedules to Favorites in MyTV section
         * @request POST:/api/v2/favorites/programs
         * @response `200` `ProgramGuide` Favorite items
         */
        v2FavoritesProgramsCreate: (data, params = {}) => this.request({
            path: `/api/v2/favorites/programs`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Favorites2
         * @name V2FavoritesVodItemsCreate
         * @summary Gets client's VOD content added to Favorites
         * @request POST:/api/v2/favorites/vodItems
         * @response `200` `OnDemandContent` Gets client's VOD content added to Favorites
         */
        v2FavoritesVodItemsCreate: (data, params = {}) => this.request({
            path: `/api/v2/favorites/vodItems`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Favorites2
         * @name V2FavoritesChannelsCreate
         * @summary Gets client's channels added to Favorites
         * @request POST:/api/v2/favorites/channels
         * @response `200` `ProtoItemCollectionWithPaging` Gets client's channels added to Favorites
         */
        v2FavoritesChannelsCreate: (data, params = {}) => this.request({
            path: `/api/v2/favorites/channels`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Genres
         * @name GenresClientCreate
         * @summary Returnes content genres for On Demand section
         * @request POST:/api/genres/client
         * @response `200` `ContentGenres` Client genres
         */
        genresClientCreate: (data, params = {}) => this.request({
            path: `/api/genres/client`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Genres
         * @name GenresAppCreate
         * @summary Returns content genres for On Demand section in Guest mode
         * @request POST:/api/genres/app
         * @response `200` `ContentGenres` Client genres
         */
        genresAppCreate: (data, params = {}) => this.request({
            path: `/api/genres/app`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Genres
         * @name GenresInternalVodClientCreate
         * @summary Get VOD internal client genres
         * @request POST:/api/genres/internal/vod/client
         * @response `200` `ContentGenres` Client internal genres
         */
        genresInternalVodClientCreate: (data, params = {}) => this.request({
            path: `/api/genres/internal/vod/client`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Genres
         * @name GenresInternalVodAppCreate
         * @summary Get VOD internal guest genres
         * @request POST:/api/genres/internal/vod/app
         * @response `200` `ContentGenres` Guest internal genres
         */
        genresInternalVodAppCreate: (data, params = {}) => this.request({
            path: `/api/genres/internal/vod/app`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Guide
         * @name GuideClientCreate
         * @summary Returns client's TV guide with specified parameters for Guide section
         * @request POST:/api/guide/client
         * @response `200` `ProgramGuide` Content for client mode
         */
        guideClientCreate: (data, params = {}) => this.request({
            path: `/api/guide/client`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Guide
         * @name GuideAppCreate
         * @summary Returns  TV guide with specified parameters for Guide section in Guest mode
         * @request POST:/api/guide/app
         * @response `200` `ProgramGuide` Content for guest mode
         */
        guideAppCreate: (data, params = {}) => this.request({
            path: `/api/guide/app`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Guide
         * @name GuideGridCreate
         * @summary Returns client's TV grid by session based request
         * @request POST:/api/guide/grid
         * @response `200` `TvGrid` OK
         */
        guideGridCreate: (data, params = {}) => this.request({
            path: `/api/guide/grid`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Returns information about an item by ID. Related type specifies the information to be returned. Related type = 2 : For TV show returns all the related items in Live TV or VCloud (for 7 days before and 7 days after). Related type = 4 : For Live TV returns the detailed information about a selected program.
         *
         * @tags Guide
         * @name GuideClientrelatedCreate
         * @summary Gets client related content by specified request.
         * @request POST:/api/guide/clientrelated
         * @response `200` `ProgramGuide` Related item
         */
        guideClientrelatedCreate: (data, params = {}) => this.request({
            path: `/api/guide/clientrelated`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Retuns the detailed information about a program by ID for Related type=4
         *
         * @tags Guide
         * @name GuideApprelatedCreate
         * @summary Gets app related content by specified request used for Guest mode.
         * @request POST:/api/guide/apprelated
         * @response `200` `ProgramGuide` Related item
         */
        guideApprelatedCreate: (data, params = {}) => this.request({
            path: `/api/guide/apprelated`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Media
         * @name MediaImageurltemplateCreate
         * @summary Returns the URL used as a template to get all images in application
         * @request POST:/api/media/imageurltemplate
         * @response `200` `string` Url
         */
        mediaImageurltemplateCreate: (data, params = {}) => this.request({
            path: `/api/media/imageurltemplate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description The URL to be used is selected depending on the situation. ImageID Url has higher priority.
         *
         * @tags Media
         * @name MediaImageurltemplatesCreate
         * @summary Returns the URLs used as templates to get all images in application
         * @request POST:/api/media/imageurltemplates
         * @response `200` `Record<string, string>` Urls
         */
        mediaImageurltemplatesCreate: (data, params = {}) => this.request({
            path: `/api/media/imageurltemplates`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Media
         * @name MediaClientStreamCreate
         * @summary Returns streaming URL for client's videostreaming request by session ID
         * @request POST:/api/media/clientStream
         * @response `200` `MediaStream` Stream
         */
        mediaClientStreamCreate: (data, params = {}) => this.request({
            path: `/api/media/clientStream`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Media
         * @name MediaRestartStreamCreate
         * @summary Returns streaming URL with vbegin for client's videostreaming request by session ID
         * @request POST:/api/media/restartStream
         * @response `200` `MediaStream` Stream
         */
        mediaRestartStreamCreate: (data, params = {}) => this.request({
            path: `/api/media/restartStream`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Method for tests
         *
         * @tags Media
         * @name MediaErrorStreamList
         * @summary Returns error status code
         * @request GET:/api/media/errorStream
         * @response `200` `HttpResponseMessage` OK
         */
        mediaErrorStreamList: (params = {}) => this.request({
            path: `/api/media/errorStream`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Media
         * @name MediaAppStreamCreate
         * @summary Returns streaming URL for app videostreaming request in Guest mode
         * @request POST:/api/media/appStream
         * @response `200` `MediaStream` Stream
         */
        mediaAppStreamCreate: (data, params = {}) => this.request({
            path: `/api/media/appStream`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Media2
         * @name V2MediaImageurltemplateCreate
         * @summary Returns the URL used as a template to get all images in application
         * @request POST:/api/v2/media/imageurltemplate
         * @response `200` `string` Url
         */
        v2MediaImageurltemplateCreate: (data, params = {}) => this.request({
            path: `/api/v2/media/imageurltemplate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description The URL to be used is selected depending on the situation. ImageID Url has higher priority.
         *
         * @tags Media2
         * @name V2MediaImageurltemplatesCreate
         * @summary Returns the URLs used as templates to get all images in application
         * @request POST:/api/v2/media/imageurltemplates
         * @response `200` `Record<string, string>` Urls
         */
        v2MediaImageurltemplatesCreate: (data, params = {}) => this.request({
            path: `/api/v2/media/imageurltemplates`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Profile
         * @name ProfilesAddCreate
         * @summary Add client profile
         * @request POST:/api/profiles/add
         * @response `200` `ProfileStatusSimpleResponse` Results: 0, -1, -2, -3
         */
        profilesAddCreate: (data, params = {}) => this.request({
            path: `/api/profiles/add`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Profile
         * @name ProfilesUpdateCreate
         * @summary Update client profile
         * @request POST:/api/profiles/update
         * @response `200` `ProfileStatusSimpleResponse` Results: 0, -1
         */
        profilesUpdateCreate: (data, params = {}) => this.request({
            path: `/api/profiles/update`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Profile
         * @name ProfilesDeleteCreate
         * @summary Delete client profile
         * @request POST:/api/profiles/delete
         * @response `200` `ProfileStatusSimpleResponse` Results: 0, -1
         */
        profilesDeleteCreate: (data, params = {}) => this.request({
            path: `/api/profiles/delete`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Profile
         * @name ProfilesActivateCreate
         * @summary Set client profile as active
         * @request POST:/api/profiles/activate
         * @response `200` `ProfileStatusSimpleResponse` Results: 0, -1
         */
        profilesActivateCreate: (data, params = {}) => this.request({
            path: `/api/profiles/activate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Profile
         * @name ProfilesValidateCreate
         * @summary Validate profile password
         * @request POST:/api/profiles/validate
         * @response `200` `BooleanSimpleResponse` OK
         */
        profilesValidateCreate: (data, params = {}) => this.request({
            path: `/api/profiles/validate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Profile
         * @name ProfilesCreate
         * @summary Get client profiles
         * @request POST:/api/profiles
         * @response `200` `(ProfileDto)[]` Client profiles
         */
        profilesCreate: (data, params = {}) => this.request({
            path: `/api/profiles`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Purchase
         * @name PurchasePaymentProfilesDetail
         * @summary Returns user payment profiles
         * @request GET:/api/purchase/paymentProfiles/{sessionId}
         * @response `200` `PaymentProfiles` OK
         */
        purchasePaymentProfilesDetail: (sessionId, params = {}) => this.request({
            path: `/api/purchase/paymentProfiles/${sessionId}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Purchase
         * @name PurchaseCodeSendDetail
         * @summary Send verification code to user email
         * @request GET:/api/purchase/code/send/{sessionId}
         * @response `200` `SendVerifyCodeStatus` OK
         */
        purchaseCodeSendDetail: (sessionId, params = {}) => this.request({
            path: `/api/purchase/code/send/${sessionId}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Purchase
         * @name PurchaseRiverPaymentDiscountCreate
         * @summary Make a river package purchase with one month trial
         * @request POST:/api/purchase/river/payment/discount
         * @response `200` `PurchaseResponse` Payment result
         */
        purchaseRiverPaymentDiscountCreate: (data, params = {}) => this.request({
            path: `/api/purchase/river/payment/discount`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Returns LiveTv items based on last watched items
         *
         * @tags Recommendations
         * @name RecommendationsTvguideCreate
         * @summary Gets recommendations for TV guide.
         * @request POST:/api/recommendations/tvguide
         * @response `200` `(ProgramGuideItem)[]` Recommendations for TV guide
         */
        recommendationsTvguideCreate: (data, params = {}) => this.request({
            path: `/api/recommendations/tvguide`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Returns VOD items based on last watched items
         *
         * @tags Recommendations
         * @name RecommendationsVodCreate
         * @summary Gets recommendations for VOD.
         * @request POST:/api/recommendations/vod
         * @response `200` `(OnDemandItem)[]` Recommendations for VOD
         */
        recommendationsVodCreate: (data, params = {}) => this.request({
            path: `/api/recommendations/vod`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Resources
         * @name ResourcesClientCreate
         * @summary Gets client resource by specified resource code
         * @request POST:/api/resources/client
         * @response `200` `string` OK
         */
        resourcesClientCreate: (data, params = {}) => this.request({
            path: `/api/resources/client`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Resources
         * @name ResourcesAppCreate
         * @summary Gets app resource by specified resource code
         * @request POST:/api/resources/app
         * @response `200` `string` OK
         */
        resourcesAppCreate: (data, params = {}) => this.request({
            path: `/api/resources/app`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags River
         * @name RiverSendcodeCreate
         * @summary Sends verification code to e-mail
         * @request POST:/api/river/sendcode
         * @response `200` `SendVerifyCodeStatusSimpleResponse` Sending verification code result
         */
        riverSendcodeCreate: (data, params = {}) => this.request({
            path: `/api/river/sendcode`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description The IP address should be Canadian. The IP address can be specified with the key "X-Auth-Forwarded-For" in the Header of request.
         *
         * @tags River
         * @name RiverRegisterCreate
         * @summary Registers a new river user
         * @request POST:/api/river/register
         * @response `200` `RegisterTrialResponse` Register new user for River packages
         */
        riverRegisterCreate: (data, params = {}) => this.request({
            path: `/api/river/register`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description The IP address should be Canadian. The IP address can be specified with the key "X-Auth-Forwarded-For" in the Header of request.
         *
         * @tags River
         * @name RiverForgotpasswordCreate
         * @summary Forgot password for river user
         * @request POST:/api/river/forgotpassword
         * @response `200` `ForgotPasswordStatusSimpleResponse` Forgot password result
         */
        riverForgotpasswordCreate: (data, params = {}) => this.request({
            path: `/api/river/forgotpassword`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description The IP address should be Canadian. The IP address can be specified with the key "X-Auth-Forwarded-For" in the Header of request.
         *
         * @tags River
         * @name RiverPackagesCreate
         * @summary Returns an array of packages by user's IP address
         * @request POST:/api/river/packages
         * @response `200` `RiverPackagesResponse` OK
         */
        riverPackagesCreate: (data, params = {}) => this.request({
            path: `/api/river/packages`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags River
         * @name RiverPackagesTrialAvailableCreate
         * @summary Check availability of trial for device
         * @request POST:/api/river/packages/trial/available
         * @response `200` `BooleanSimpleResponse` OK
         */
        riverPackagesTrialAvailableCreate: (data, params = {}) => this.request({
            path: `/api/river/packages/trial/available`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description The IP address should be Canadian. The IP address can be specified with the key "X-Auth-Forwarded-For" in the Header of request.
         *
         * @tags River
         * @name RiverTransactionValidateCreate
         * @summary Validates the transaction of purchasing a package by a user
         * @request POST:/api/river/transaction/validate
         * @response `200` `ValidateRiverPayResult` Validates the transaction
         */
        riverTransactionValidateCreate: (data, params = {}) => this.request({
            path: `/api/river/transaction/validate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Canadian IP address is needed. The IP address can be specified with the key "X-Auth-Forwarded-For" in the Header of request
         *
         * @tags River
         * @name RiverSigninCreate
         * @summary Makes sign in of a user with authorization platform by the token
         * @request POST:/api/river/signin
         * @response `200` `SignInResponse` Sign in
         */
        riverSigninCreate: (data, params = {}) => this.request({
            path: `/api/river/signin`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Canadian IP address is needed. The IP address can be specified with the key "X-Auth-Forwarded-For" in the Header of request
         *
         * @tags River
         * @name RiverSigninRegisterCreate
         * @summary Makes sign in of a user with authorization platform by the token and create new user
         * @request POST:/api/river/signin/register
         * @response `200` `SignInResponse` Sign in
         */
        riverSigninRegisterCreate: (data, params = {}) => this.request({
            path: `/api/river/signin/register`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags River
         * @name RiverTransactionGuestCreate
         * @summary Validate a store transaction in guest mode (without session)
         * @request POST:/api/river/transaction/guest
         * @response `200` `GuestTransactionResult` Guest mode for validation store transaction
         */
        riverTransactionGuestCreate: (data, params = {}) => this.request({
            path: `/api/river/transaction/guest`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Enable cache control to avoid flooding from the devices. They sometimes go into an infinite loop and start calling the method thousands of times per minute. Only legacy Android devices use the method, new devices don't need it at all.
         *
         * @tags Time
         * @name TimeUtcCreate
         * @summary Returns current date and time in Unix Timestamp format
         * @request POST:/api/time/utc
         * @response `200` `string` OK
         */
        timeUtcCreate: (params = {}) => this.request({
            path: `/api/time/utc`,
            method: "POST",
            format: "json",
            ...params,
        }),
        /**
         * @description Enable cache control to avoid flooding from the devices. They sometimes go into an infinite loop and start calling the method thousands of times per minute. Only legacy Android devices use the method, new devices don't need it at all.
         *
         * @tags Time
         * @name TimeUtcList
         * @summary Returns current date and time in Unix Timestamp format
         * @request GET:/api/time/utc
         * @response `200` `string` OK
         */
        timeUtcList: (params = {}) => this.request({
            path: `/api/time/utc`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Time
         * @name TimeZonenamesCreate
         * @summary Returns array of full zone names
         * @request POST:/api/time/zonenames
         * @response `200` `(string)[]` OK
         */
        timeZonenamesCreate: (params = {}) => this.request({
            path: `/api/time/zonenames`,
            method: "POST",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Time
         * @name TimeZonenamesList
         * @summary Returns array of full zone names
         * @request GET:/api/time/zonenames
         * @response `200` `(string)[]` OK
         */
        timeZonenamesList: (params = {}) => this.request({
            path: `/api/time/zonenames`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Time
         * @name TimeZonesCreate
         * @summary Returns all time zones and their properties
         * @request POST:/api/time/zones
         * @response `200` `(MediaTimeZone)[]` OK
         */
        timeZonesCreate: (params = {}) => this.request({
            path: `/api/time/zones`,
            method: "POST",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Time
         * @name TimeZonesList
         * @summary Returns all time zones and their properties
         * @request GET:/api/time/zones
         * @response `200` `(MediaTimeZone)[]` OK
         */
        timeZonesList: (params = {}) => this.request({
            path: `/api/time/zones`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Canadian IP address is needed. The IP address can be specified with the key "X-Auth-Forwarded-For" in the Header of request
         *
         * @tags Trial
         * @name TrialValidatedeviceCreate
         * @summary Validates the device and returns service provider type
         * @request POST:/api/trial/validatedevice
         * @response `200` `ValidateDeviceResponse` Validate device
         */
        trialValidatedeviceCreate: (data, params = {}) => this.request({
            path: `/api/trial/validatedevice`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Canadian IP address is needed. The IP address can be specified with the key "X-Auth-Forwarded-For" in the Header of request. In case only phone number (or e-mail) is specified, the validation code will be sent to it.
         *
         * @tags Trial
         * @name TrialRegisterCreate
         * @summary Register a new user for Trial
         * @request POST:/api/trial/register
         * @response `200` `RegisterTrialResponse` Register new user
         */
        trialRegisterCreate: (data, params = {}) => this.request({
            path: `/api/trial/register`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Canadian IP address is needed. The IP address can be specified with the key "X-Auth-Forwarded-For" in the Header of request.
         *
         * @tags Trial
         * @name TrialPackagesCreate
         * @summary Returns an array of trial packages assigned to a user by session based request
         * @request POST:/api/trial/packages
         * @response `200` `TrialPackagesGetResponse` OK
         */
        trialPackagesCreate: (data, params = {}) => this.request({
            path: `/api/trial/packages`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Canadian IP address is needed. The IP address can be specified with the key "X-Auth-Forwarded-For" in the Header of request.
         *
         * @tags Trial
         * @name TrialPackagesAddCreate
         * @summary Adds a a trial package to a user by session based request
         * @request POST:/api/trial/packages/add
         * @response `200` `TrialPackagesAddResponse` OK
         */
        trialPackagesAddCreate: (data, params = {}) => this.request({
            path: `/api/trial/packages/add`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description For success send sms on dev environment use phone = +15005550006 or null/empty. Canadian IP address is needed. The IP address can be specified with the key "X-Auth-Forwarded-For" in the Header of request.
         *
         * @tags Trial
         * @name TrialSendcodeCreate
         * @summary Sends verification code to phone number and e-mail (or one of them)
         * @request POST:/api/trial/sendcode
         * @response `200` `GenerateVerificationCodeResponse` Verification code generation result
         */
        trialSendcodeCreate: (data, params = {}) => this.request({
            path: `/api/trial/sendcode`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Type = 9,10,11 for On Demand content
         *
         * @tags Vod
         * @name VodClientCreate
         * @summary Gets client's On Demand content
         * @request POST:/api/vod/client
         * @response `200` `OnDemandContent` Client VOD content
         */
        vodClientCreate: (data, params = {}) => this.request({
            path: `/api/vod/client`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Vod
         * @name VodAppCreate
         * @summary Returns On Demand items for specified VOD type used in Guest mode
         * @request POST:/api/vod/app
         * @response `200` `OnDemandContent` App VOD content
         */
        vodAppCreate: (data, params = {}) => this.request({
            path: `/api/vod/app`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Related type = 1 : related items for a certain multipart title of VOD; Related type = 4 : Gets detailed information about a certain title of VOD
         *
         * @tags Vod
         * @name VodClientrelatedCreate
         * @summary Gets related content for a specified VOD item
         * @request POST:/api/vod/clientrelated
         * @response `200` `OnDemandContent` Related item
         */
        vodClientrelatedCreate: (data, params = {}) => this.request({
            path: `/api/vod/clientrelated`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Vod
         * @name VodApprelatedCreate
         * @summary Gets related content for specified VOD item in Guest mode
         * @request POST:/api/vod/apprelated
         * @response `200` `OnDemandContent` App related item
         */
        vodApprelatedCreate: (data, params = {}) => this.request({
            path: `/api/vod/apprelated`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Vod
         * @name VodFavfilterCreate
         * @summary Gets client's VOD content added to Favorites
         * @request POST:/api/vod/favfilter
         * @response `200` `OnDemandContent` Gets client's VOD content added to Favorites
         */
        vodFavfilterCreate: (data, params = {}) => this.request({
            path: `/api/vod/favfilter`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags VoiceCommands
         * @name VoicecommandsMappingsCreate
         * @summary Returns Voice Commands mappings for VBOX
         * @request POST:/api/voicecommands/mappings
         * @response `200` `VoiceCommandsMapping` OK
         */
        voicecommandsMappingsCreate: (data, params = {}) => this.request({
            path: `/api/voicecommands/mappings`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    system = {
        /**
         * No description
         *
         * @tags Streaming
         * @name ApiAccessDetail
         * @summary Get publishing point pgp-key
         * @request GET:/system/api/access/{pubPointName}/{port}
         * @response `200` `void` OK
         */
        apiAccessDetail: (pubPointName, port, params = {}) => this.request({
            path: `/system/api/access/${pubPointName}/${port}`,
            method: "GET",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Streaming
         * @name ApiAccessDetail2
         * @summary Set publishing point pgp-key
         * @request GET:/system/api/access/{pubPointName}/{port}/{key}
         * @originalName apiAccessDetail
         * @duplicate
         * @response `200` `void` OK
         */
        apiAccessDetail2: (pubPointName, port, key, params = {}) => this.request({
            path: `/system/api/access/${pubPointName}/${port}/${key}`,
            method: "GET",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Streaming
         * @name ApiAccessSetMaintenancesCreate
         * @summary Set channel maintenance statuses
         * @request POST:/system/api/access/set-maintenances
         * @response `200` `void` OK
         */
        apiAccessSetMaintenancesCreate: (data, params = {}) => this.request({
            path: `/system/api/access/set-maintenances`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
    };
}

export { AccessOptions, AdditionalPriceType, Advisory, Api, ApiCode, AppleContentLevel, Brand, CheckoutType, ClientMessageType, ConditionType, ContentGenreType, ContentType, CreditsRequestType, DrmBehavior, DrmType, ForgotPasswordStatus, GenreType, GuestTransactionStatus, HttpClient, HttpStatusCode, HttpVersionPolicy, ItemType, Language, LevelSubscription, LocMedicalHospital, MediaImageTypes, MediaRequestTypes, OnDemandRequestType, PaymentMethod, PaymentStatus, PaymentType, PlatformDeviceType, ProfileStatus, ProgramType, Provider, ReceiptVerificationResultStatus, RecordingStatus, RecordingType, RegistrationByMacStatus, RegistrationStatus, RelatedChannelType, RelatedType, RestrictionType, RiverRegistrationType, RiverStatus, SendVerifyCodeStatus, ServiceProviderType, ShowTypes, Status, StreamQualityPreset, TokenProvider, TransactionValidationStatus, TrialStatus, TrickModeRestriction, TvQualifier, UpdateRequirementsType, VerificationCodeStatus, VodType, WordGroupType };
